/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /** The day, does not include a time. */
  Date: { input: any; output: any; }
};

export type Assistant = Node & {
  __typename?: 'Assistant';
  active: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `AssistantConstituencyOffice`. */
  assistantConstituencyOfficesByAssistantId: AssistantConstituencyOfficesConnection;
  /** Reads and enables pagination through a set of `AssistantMember`. */
  assistantMembersByAssistantId: AssistantMembersConnection;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Party` that is related to this `Assistant`. */
  partyByPartyId?: Maybe<Party>;
  partyId?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};


export type AssistantAssistantConstituencyOfficesByAssistantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssistantConstituencyOfficeCondition>;
  filter?: InputMaybe<AssistantConstituencyOfficeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssistantConstituencyOfficesOrderBy>>;
};


export type AssistantAssistantMembersByAssistantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssistantMemberCondition>;
  filter?: InputMaybe<AssistantMemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssistantMembersOrderBy>>;
};

/**
 * A condition to be used against `Assistant` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AssistantCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `partyId` field. */
  partyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AssistantConstituencyOffice = Node & {
  __typename?: 'AssistantConstituencyOffice';
  /** Reads a single `Assistant` that is related to this `AssistantConstituencyOffice`. */
  assistantByAssistantId?: Maybe<Assistant>;
  assistantId: Scalars['Int']['output'];
  /** Reads a single `Constituency` that is related to this `AssistantConstituencyOffice`. */
  constituencyByConstituencyOfficeId?: Maybe<Constituency>;
  constituencyOfficeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `AssistantConstituencyOffice` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AssistantConstituencyOfficeCondition = {
  /** Checks for equality with the object’s `assistantId` field. */
  assistantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `constituencyOfficeId` field. */
  constituencyOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `AssistantConstituencyOffice` object types. All fields are combined with a logical ‘and.’ */
export type AssistantConstituencyOfficeFilter = {
  /** Filter by the object’s `assistantByAssistantId` relation. */
  assistantByAssistantId?: InputMaybe<AssistantFilter>;
  /** Filter by the object’s `assistantId` field. */
  assistantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `constituencyByConstituencyOfficeId` relation. */
  constituencyByConstituencyOfficeId?: InputMaybe<ConstituencyFilter>;
  /** Filter by the object’s `constituencyOfficeId` field. */
  constituencyOfficeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
};

/** A connection to a list of `AssistantConstituencyOffice` values. */
export type AssistantConstituencyOfficesConnection = {
  __typename?: 'AssistantConstituencyOfficesConnection';
  /** A list of edges which contains the `AssistantConstituencyOffice` and cursor to aid in pagination. */
  edges: Array<AssistantConstituencyOfficesEdge>;
  /** A list of `AssistantConstituencyOffice` objects. */
  nodes: Array<AssistantConstituencyOffice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AssistantConstituencyOffice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AssistantConstituencyOffice` edge in the connection. */
export type AssistantConstituencyOfficesEdge = {
  __typename?: 'AssistantConstituencyOfficesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AssistantConstituencyOffice` at the end of the edge. */
  node: AssistantConstituencyOffice;
};

/** Methods to use when ordering `AssistantConstituencyOffice`. */
export enum AssistantConstituencyOfficesOrderBy {
  AssistantIdAsc = 'ASSISTANT_ID_ASC',
  AssistantIdDesc = 'ASSISTANT_ID_DESC',
  ConstituencyOfficeIdAsc = 'CONSTITUENCY_OFFICE_ID_ASC',
  ConstituencyOfficeIdDesc = 'CONSTITUENCY_OFFICE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against `Assistant` object types. All fields are combined with a logical ‘and.’ */
export type AssistantFilter = {
  /** Filter by the object’s `assistantConstituencyOfficesByAssistantId` relation. */
  assistantConstituencyOfficesByAssistantId?: InputMaybe<AssistantToManyAssistantConstituencyOfficeFilter>;
  /** Some related `assistantConstituencyOfficesByAssistantId` exist. */
  assistantConstituencyOfficesByAssistantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `assistantMembersByAssistantId` relation. */
  assistantMembersByAssistantId?: InputMaybe<AssistantToManyAssistantMemberFilter>;
  /** Some related `assistantMembersByAssistantId` exist. */
  assistantMembersByAssistantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `partyByPartyId` relation. */
  partyByPartyId?: InputMaybe<PartyFilter>;
  /** A related `partyByPartyId` exists. */
  partyByPartyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `partyId` field. */
  partyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
};

export type AssistantMember = Node & {
  __typename?: 'AssistantMember';
  /** Reads a single `Assistant` that is related to this `AssistantMember`. */
  assistantByAssistantId?: Maybe<Assistant>;
  assistantId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Reads a single `Member` that is related to this `AssistantMember`. */
  memberByMemberId?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `AssistantMember` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AssistantMemberCondition = {
  /** Checks for equality with the object’s `assistantId` field. */
  assistantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `AssistantMember` object types. All fields are combined with a logical ‘and.’ */
export type AssistantMemberFilter = {
  /** Filter by the object’s `assistantByAssistantId` relation. */
  assistantByAssistantId?: InputMaybe<AssistantFilter>;
  /** Filter by the object’s `assistantId` field. */
  assistantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `AssistantMember` values. */
export type AssistantMembersConnection = {
  __typename?: 'AssistantMembersConnection';
  /** A list of edges which contains the `AssistantMember` and cursor to aid in pagination. */
  edges: Array<AssistantMembersEdge>;
  /** A list of `AssistantMember` objects. */
  nodes: Array<AssistantMember>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AssistantMember` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AssistantMember` edge in the connection. */
export type AssistantMembersEdge = {
  __typename?: 'AssistantMembersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AssistantMember` at the end of the edge. */
  node: AssistantMember;
};

/** Methods to use when ordering `AssistantMember`. */
export enum AssistantMembersOrderBy {
  AssistantIdAsc = 'ASSISTANT_ID_ASC',
  AssistantIdDesc = 'ASSISTANT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against many `AssistantConstituencyOffice` object types. All fields are combined with a logical ‘and.’ */
export type AssistantToManyAssistantConstituencyOfficeFilter = {
  /** Every related `AssistantConstituencyOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssistantConstituencyOfficeFilter>;
  /** No related `AssistantConstituencyOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssistantConstituencyOfficeFilter>;
  /** Some related `AssistantConstituencyOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssistantConstituencyOfficeFilter>;
};

/** A filter to be used against many `AssistantMember` object types. All fields are combined with a logical ‘and.’ */
export type AssistantToManyAssistantMemberFilter = {
  /** Every related `AssistantMember` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssistantMemberFilter>;
  /** No related `AssistantMember` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssistantMemberFilter>;
  /** Some related `AssistantMember` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssistantMemberFilter>;
};

/** A connection to a list of `Assistant` values. */
export type AssistantsConnection = {
  __typename?: 'AssistantsConnection';
  /** A list of edges which contains the `Assistant` and cursor to aid in pagination. */
  edges: Array<AssistantsEdge>;
  /** A list of `Assistant` objects. */
  nodes: Array<Assistant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Assistant` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Assistant` edge in the connection. */
export type AssistantsEdge = {
  __typename?: 'AssistantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Assistant` at the end of the edge. */
  node: Assistant;
};

/** Methods to use when ordering `Assistant`. */
export enum AssistantsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PartyIdAsc = 'PARTY_ID_ASC',
  PartyIdDesc = 'PARTY_ID_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Clerk = Node & {
  __typename?: 'Clerk';
  active: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

/** A condition to be used against `Clerk` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ClerkCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Clerk` object types. All fields are combined with a logical ‘and.’ */
export type ClerkFilter = {
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
};

export type ClerkType = Node & {
  __typename?: 'ClerkType';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `ClerkType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ClerkTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ClerkType` object types. All fields are combined with a logical ‘and.’ */
export type ClerkTypeFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ClerkType` values. */
export type ClerkTypesConnection = {
  __typename?: 'ClerkTypesConnection';
  /** A list of edges which contains the `ClerkType` and cursor to aid in pagination. */
  edges: Array<ClerkTypesEdge>;
  /** A list of `ClerkType` objects. */
  nodes: Array<ClerkType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClerkType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ClerkType` edge in the connection. */
export type ClerkTypesEdge = {
  __typename?: 'ClerkTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ClerkType` at the end of the edge. */
  node: ClerkType;
};

/** Methods to use when ordering `ClerkType`. */
export enum ClerkTypesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Clerk` values. */
export type ClerksConnection = {
  __typename?: 'ClerksConnection';
  /** A list of edges which contains the `Clerk` and cursor to aid in pagination. */
  edges: Array<ClerksEdge>;
  /** A list of `Clerk` objects. */
  nodes: Array<Clerk>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Clerk` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Clerk` edge in the connection. */
export type ClerksEdge = {
  __typename?: 'ClerksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Clerk` at the end of the edge. */
  node: Clerk;
};

/** Methods to use when ordering `Clerk`. */
export enum ClerksOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Community` values. */
export type CommunitiesConnection = {
  __typename?: 'CommunitiesConnection';
  /** A list of edges which contains the `Community` and cursor to aid in pagination. */
  edges: Array<CommunitiesEdge>;
  /** A list of `Community` objects. */
  nodes: Array<Community>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Community` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Community` edge in the connection. */
export type CommunitiesEdge = {
  __typename?: 'CommunitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Community` at the end of the edge. */
  node: Community;
};

/** Methods to use when ordering `Community`. */
export enum CommunitiesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  ConstituencyIdAsc = 'CONSTITUENCY_ID_ASC',
  ConstituencyIdDesc = 'CONSTITUENCY_ID_DESC',
  ElectoralMapLabelAsc = 'ELECTORAL_MAP_LABEL_ASC',
  ElectoralMapLabelDesc = 'ELECTORAL_MAP_LABEL_DESC',
  ElectoralMapLinkAsc = 'ELECTORAL_MAP_LINK_ASC',
  ElectoralMapLinkDesc = 'ELECTORAL_MAP_LINK_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type Community = Node & {
  __typename?: 'Community';
  active: Scalars['Boolean']['output'];
  /** Reads a single `Constituency` that is related to this `Community`. */
  constituencyByConstituencyId?: Maybe<Constituency>;
  constituencyId?: Maybe<Scalars['Int']['output']>;
  electoralMapLabel?: Maybe<Scalars['String']['output']>;
  electoralMapLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/**
 * A condition to be used against `Community` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CommunityCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `electoralMapLabel` field. */
  electoralMapLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `electoralMapLink` field. */
  electoralMapLink?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Community` object types. All fields are combined with a logical ‘and.’ */
export type CommunityFilter = {
  /** Filter by the object’s `constituencyByConstituencyId` relation. */
  constituencyByConstituencyId?: InputMaybe<ConstituencyFilter>;
  /** A related `constituencyByConstituencyId` exists. */
  constituencyByConstituencyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `electoralMapLabel` field. */
  electoralMapLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `electoralMapLink` field. */
  electoralMapLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
};

/** A connection to a list of `Constituency` values. */
export type ConstituenciesConnection = {
  __typename?: 'ConstituenciesConnection';
  /** A list of edges which contains the `Constituency` and cursor to aid in pagination. */
  edges: Array<ConstituenciesEdge>;
  /** A list of `Constituency` objects. */
  nodes: Array<Constituency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Constituency` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Constituency` edge in the connection. */
export type ConstituenciesEdge = {
  __typename?: 'ConstituenciesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Constituency` at the end of the edge. */
  node: Constituency;
};

/** Methods to use when ordering `Constituency`. */
export enum ConstituenciesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  ElectoralCodeAsc = 'ELECTORAL_CODE_ASC',
  ElectoralCodeDesc = 'ELECTORAL_CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Constituency = Node & {
  __typename?: 'Constituency';
  active: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `AssistantConstituencyOffice`. */
  assistantConstituencyOfficesByConstituencyOfficeId: AssistantConstituencyOfficesConnection;
  /** Reads and enables pagination through a set of `Community`. */
  communitiesByConstituencyId: CommunitiesConnection;
  /** Reads and enables pagination through a set of `ConstituencyOffice`. */
  constituencyOfficesByConstituencyId: ConstituencyOfficesConnection;
  electoralCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `Member` that is related to this `Constituency`. */
  memberByMemberId?: Maybe<Member>;
  /** Reads and enables pagination through a set of `MemberElection`. */
  memberElectionsByConstituencyId: MemberElectionsConnection;
  memberId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `MemberParliament`. */
  memberParliamentsByConstituencyId: MemberParliamentsConnection;
  /** Reads and enables pagination through a set of `Member`. */
  membersByConstituencyId: MembersConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `PostalCodeLookup`. */
  postalCodeLookupsByConstituencyId: PostalCodeLookupsConnection;
};


export type ConstituencyAssistantConstituencyOfficesByConstituencyOfficeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssistantConstituencyOfficeCondition>;
  filter?: InputMaybe<AssistantConstituencyOfficeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssistantConstituencyOfficesOrderBy>>;
};


export type ConstituencyCommunitiesByConstituencyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommunityCondition>;
  filter?: InputMaybe<CommunityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommunitiesOrderBy>>;
};


export type ConstituencyConstituencyOfficesByConstituencyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConstituencyOfficeCondition>;
  filter?: InputMaybe<ConstituencyOfficeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConstituencyOfficesOrderBy>>;
};


export type ConstituencyMemberElectionsByConstituencyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberElectionCondition>;
  filter?: InputMaybe<MemberElectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberElectionsOrderBy>>;
};


export type ConstituencyMemberParliamentsByConstituencyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


export type ConstituencyMembersByConstituencyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};


export type ConstituencyPostalCodeLookupsByConstituencyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PostalCodeLookupCondition>;
  filter?: InputMaybe<PostalCodeLookupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PostalCodeLookupsOrderBy>>;
};

/**
 * A condition to be used against `Constituency` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ConstituencyCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `electoralCode` field. */
  electoralCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Constituency` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyFilter = {
  /** Filter by the object’s `assistantConstituencyOfficesByConstituencyOfficeId` relation. */
  assistantConstituencyOfficesByConstituencyOfficeId?: InputMaybe<ConstituencyToManyAssistantConstituencyOfficeFilter>;
  /** Some related `assistantConstituencyOfficesByConstituencyOfficeId` exist. */
  assistantConstituencyOfficesByConstituencyOfficeIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `communitiesByConstituencyId` relation. */
  communitiesByConstituencyId?: InputMaybe<ConstituencyToManyCommunityFilter>;
  /** Some related `communitiesByConstituencyId` exist. */
  communitiesByConstituencyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `constituencyOfficesByConstituencyId` relation. */
  constituencyOfficesByConstituencyId?: InputMaybe<ConstituencyToManyConstituencyOfficeFilter>;
  /** Some related `constituencyOfficesByConstituencyId` exist. */
  constituencyOfficesByConstituencyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `electoralCode` field. */
  electoralCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** A related `memberByMemberId` exists. */
  memberByMemberIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberElectionsByConstituencyId` relation. */
  memberElectionsByConstituencyId?: InputMaybe<ConstituencyToManyMemberElectionFilter>;
  /** Some related `memberElectionsByConstituencyId` exist. */
  memberElectionsByConstituencyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberParliamentsByConstituencyId` relation. */
  memberParliamentsByConstituencyId?: InputMaybe<ConstituencyToManyMemberParliamentFilter>;
  /** Some related `memberParliamentsByConstituencyId` exist. */
  memberParliamentsByConstituencyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membersByConstituencyId` relation. */
  membersByConstituencyId?: InputMaybe<ConstituencyToManyMemberFilter>;
  /** Some related `membersByConstituencyId` exist. */
  membersByConstituencyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `postalCodeLookupsByConstituencyId` relation. */
  postalCodeLookupsByConstituencyId?: InputMaybe<ConstituencyToManyPostalCodeLookupFilter>;
  /** Some related `postalCodeLookupsByConstituencyId` exist. */
  postalCodeLookupsByConstituencyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConstituencyOffice = Node & {
  __typename?: 'ConstituencyOffice';
  active: Scalars['Boolean']['output'];
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  /** Reads a single `Constituency` that is related to this `ConstituencyOffice`. */
  constituencyByConstituencyId?: Maybe<Constituency>;
  constituencyId: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Reads and enables pagination through a set of `MemberConstituency`. */
  memberConstituenciesByConstituencyOfficeId: MemberConstituenciesConnection;
  /** Reads and enables pagination through a set of `MemberParliament`. */
  memberParliamentsByPrimaryConstituencyOfficeId: MemberParliamentsConnection;
  /** Reads and enables pagination through a set of `Member`. */
  membersByPrimaryConstituencyOfficeId: MembersConnection;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalcode: Scalars['String']['output'];
  province: Scalars['String']['output'];
  tollFreePhone?: Maybe<Scalars['String']['output']>;
};


export type ConstituencyOfficeMemberConstituenciesByConstituencyOfficeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberConstituencyCondition>;
  filter?: InputMaybe<MemberConstituencyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberConstituenciesOrderBy>>;
};


export type ConstituencyOfficeMemberParliamentsByPrimaryConstituencyOfficeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


export type ConstituencyOfficeMembersByPrimaryConstituencyOfficeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};

/**
 * A condition to be used against `ConstituencyOffice` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ConstituencyOfficeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fax` field. */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `latitude` field. */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `longitude` field. */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `postalcode` field. */
  postalcode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `province` field. */
  province?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tollFreePhone` field. */
  tollFreePhone?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ConstituencyOffice` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyOfficeFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `constituencyByConstituencyId` relation. */
  constituencyByConstituencyId?: InputMaybe<ConstituencyFilter>;
  /** Filter by the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fax` field. */
  fax?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberConstituenciesByConstituencyOfficeId` relation. */
  memberConstituenciesByConstituencyOfficeId?: InputMaybe<ConstituencyOfficeToManyMemberConstituencyFilter>;
  /** Some related `memberConstituenciesByConstituencyOfficeId` exist. */
  memberConstituenciesByConstituencyOfficeIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberParliamentsByPrimaryConstituencyOfficeId` relation. */
  memberParliamentsByPrimaryConstituencyOfficeId?: InputMaybe<ConstituencyOfficeToManyMemberParliamentFilter>;
  /** Some related `memberParliamentsByPrimaryConstituencyOfficeId` exist. */
  memberParliamentsByPrimaryConstituencyOfficeIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membersByPrimaryConstituencyOfficeId` relation. */
  membersByPrimaryConstituencyOfficeId?: InputMaybe<ConstituencyOfficeToManyMemberFilter>;
  /** Some related `membersByPrimaryConstituencyOfficeId` exist. */
  membersByPrimaryConstituencyOfficeIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `postalcode` field. */
  postalcode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `province` field. */
  province?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tollFreePhone` field. */
  tollFreePhone?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `MemberConstituency` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyOfficeToManyMemberConstituencyFilter = {
  /** Every related `MemberConstituency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberConstituencyFilter>;
  /** No related `MemberConstituency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberConstituencyFilter>;
  /** Some related `MemberConstituency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberConstituencyFilter>;
};

/** A filter to be used against many `Member` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyOfficeToManyMemberFilter = {
  /** Every related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberFilter>;
  /** No related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberFilter>;
  /** Some related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberFilter>;
};

/** A filter to be used against many `MemberParliament` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyOfficeToManyMemberParliamentFilter = {
  /** Every related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberParliamentFilter>;
  /** No related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberParliamentFilter>;
  /** Some related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberParliamentFilter>;
};

/** A connection to a list of `ConstituencyOffice` values. */
export type ConstituencyOfficesConnection = {
  __typename?: 'ConstituencyOfficesConnection';
  /** A list of edges which contains the `ConstituencyOffice` and cursor to aid in pagination. */
  edges: Array<ConstituencyOfficesEdge>;
  /** A list of `ConstituencyOffice` objects. */
  nodes: Array<ConstituencyOffice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ConstituencyOffice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ConstituencyOffice` edge in the connection. */
export type ConstituencyOfficesEdge = {
  __typename?: 'ConstituencyOfficesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ConstituencyOffice` at the end of the edge. */
  node: ConstituencyOffice;
};

/** Methods to use when ordering `ConstituencyOffice`. */
export enum ConstituencyOfficesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  ConstituencyIdAsc = 'CONSTITUENCY_ID_ASC',
  ConstituencyIdDesc = 'CONSTITUENCY_ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FaxAsc = 'FAX_ASC',
  FaxDesc = 'FAX_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LatitudeAsc = 'LATITUDE_ASC',
  LatitudeDesc = 'LATITUDE_DESC',
  LongitudeAsc = 'LONGITUDE_ASC',
  LongitudeDesc = 'LONGITUDE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  PostalcodeAsc = 'POSTALCODE_ASC',
  PostalcodeDesc = 'POSTALCODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProvinceAsc = 'PROVINCE_ASC',
  ProvinceDesc = 'PROVINCE_DESC',
  TollFreePhoneAsc = 'TOLL_FREE_PHONE_ASC',
  TollFreePhoneDesc = 'TOLL_FREE_PHONE_DESC'
}

/** A filter to be used against many `AssistantConstituencyOffice` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyToManyAssistantConstituencyOfficeFilter = {
  /** Every related `AssistantConstituencyOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssistantConstituencyOfficeFilter>;
  /** No related `AssistantConstituencyOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssistantConstituencyOfficeFilter>;
  /** Some related `AssistantConstituencyOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssistantConstituencyOfficeFilter>;
};

/** A filter to be used against many `Community` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyToManyCommunityFilter = {
  /** Every related `Community` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CommunityFilter>;
  /** No related `Community` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CommunityFilter>;
  /** Some related `Community` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CommunityFilter>;
};

/** A filter to be used against many `ConstituencyOffice` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyToManyConstituencyOfficeFilter = {
  /** Every related `ConstituencyOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ConstituencyOfficeFilter>;
  /** No related `ConstituencyOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ConstituencyOfficeFilter>;
  /** Some related `ConstituencyOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ConstituencyOfficeFilter>;
};

/** A filter to be used against many `MemberElection` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyToManyMemberElectionFilter = {
  /** Every related `MemberElection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberElectionFilter>;
  /** No related `MemberElection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberElectionFilter>;
  /** Some related `MemberElection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberElectionFilter>;
};

/** A filter to be used against many `Member` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyToManyMemberFilter = {
  /** Every related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberFilter>;
  /** No related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberFilter>;
  /** Some related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberFilter>;
};

/** A filter to be used against many `MemberParliament` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyToManyMemberParliamentFilter = {
  /** Every related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberParliamentFilter>;
  /** No related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberParliamentFilter>;
  /** Some related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberParliamentFilter>;
};

/** A filter to be used against many `PostalCodeLookup` object types. All fields are combined with a logical ‘and.’ */
export type ConstituencyToManyPostalCodeLookupFilter = {
  /** Every related `PostalCodeLookup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostalCodeLookupFilter>;
  /** No related `PostalCodeLookup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostalCodeLookupFilter>;
  /** Some related `PostalCodeLookup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostalCodeLookupFilter>;
};

export type ExecutiveCouncil = Node & {
  __typename?: 'ExecutiveCouncil';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** Reads a single `Member` that is related to this `ExecutiveCouncil`. */
  memberByMemberId?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  responsibility?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ExecutiveCouncil` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ExecutiveCouncilCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `responsibility` field. */
  responsibility?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ExecutiveCouncil` object types. All fields are combined with a logical ‘and.’ */
export type ExecutiveCouncilFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** A related `memberByMemberId` exists. */
  memberByMemberIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `responsibility` field. */
  responsibility?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ExecutiveCouncil` values. */
export type ExecutiveCouncilsConnection = {
  __typename?: 'ExecutiveCouncilsConnection';
  /** A list of edges which contains the `ExecutiveCouncil` and cursor to aid in pagination. */
  edges: Array<ExecutiveCouncilsEdge>;
  /** A list of `ExecutiveCouncil` objects. */
  nodes: Array<ExecutiveCouncil>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExecutiveCouncil` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ExecutiveCouncil` edge in the connection. */
export type ExecutiveCouncilsEdge = {
  __typename?: 'ExecutiveCouncilsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ExecutiveCouncil` at the end of the edge. */
  node: ExecutiveCouncil;
};

/** Methods to use when ordering `ExecutiveCouncil`. */
export enum ExecutiveCouncilsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResponsibilityAsc = 'RESPONSIBILITY_ASC',
  ResponsibilityDesc = 'RESPONSIBILITY_DESC'
}

export type ExecutiveStaff = Node & {
  __typename?: 'ExecutiveStaff';
  active: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ExecutiveStaff` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ExecutiveStaffCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ExecutiveStaff` object types. All fields are combined with a logical ‘and.’ */
export type ExecutiveStaffFilter = {
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
};

export type ExecutiveStaffPosition = Node & {
  __typename?: 'ExecutiveStaffPosition';
  active: Scalars['Boolean']['output'];
  executiveStaffId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  positionTypeId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `ExecutiveStaffPosition` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ExecutiveStaffPositionCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `executiveStaffId` field. */
  executiveStaffId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `positionTypeId` field. */
  positionTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ExecutiveStaffPosition` object types. All fields are combined with a logical ‘and.’ */
export type ExecutiveStaffPositionFilter = {
  /** Filter by the object’s `executiveStaffId` field. */
  executiveStaffId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `positionTypeId` field. */
  positionTypeId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `ExecutiveStaffPosition` values. */
export type ExecutiveStaffPositionsConnection = {
  __typename?: 'ExecutiveStaffPositionsConnection';
  /** A list of edges which contains the `ExecutiveStaffPosition` and cursor to aid in pagination. */
  edges: Array<ExecutiveStaffPositionsEdge>;
  /** A list of `ExecutiveStaffPosition` objects. */
  nodes: Array<ExecutiveStaffPosition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExecutiveStaffPosition` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ExecutiveStaffPosition` edge in the connection. */
export type ExecutiveStaffPositionsEdge = {
  __typename?: 'ExecutiveStaffPositionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ExecutiveStaffPosition` at the end of the edge. */
  node: ExecutiveStaffPosition;
};

/** Methods to use when ordering `ExecutiveStaffPosition`. */
export enum ExecutiveStaffPositionsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  ExecutiveStaffIdAsc = 'EXECUTIVE_STAFF_ID_ASC',
  ExecutiveStaffIdDesc = 'EXECUTIVE_STAFF_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PositionTypeIdAsc = 'POSITION_TYPE_ID_ASC',
  PositionTypeIdDesc = 'POSITION_TYPE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `ExecutiveStaff` values. */
export type ExecutiveStaffsConnection = {
  __typename?: 'ExecutiveStaffsConnection';
  /** A list of edges which contains the `ExecutiveStaff` and cursor to aid in pagination. */
  edges: Array<ExecutiveStaffsEdge>;
  /** A list of `ExecutiveStaff` objects. */
  nodes: Array<ExecutiveStaff>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExecutiveStaff` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ExecutiveStaff` edge in the connection. */
export type ExecutiveStaffsEdge = {
  __typename?: 'ExecutiveStaffsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ExecutiveStaff` at the end of the edge. */
  node: ExecutiveStaff;
};

/** Methods to use when ordering `ExecutiveStaff`. */
export enum ExecutiveStaffsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Image = Node & {
  __typename?: 'Image';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `MemberParliament`. */
  memberParliamentsByMediumImageId: MemberParliamentsConnection;
  /** Reads and enables pagination through a set of `MemberParliament`. */
  memberParliamentsBySmallImageId: MemberParliamentsConnection;
  /** Reads and enables pagination through a set of `Member`. */
  membersByMediumImageId: MembersConnection;
  /** Reads and enables pagination through a set of `Member`. */
  membersBySmallImageId: MembersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};


export type ImageMemberParliamentsByMediumImageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


export type ImageMemberParliamentsBySmallImageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


export type ImageMembersByMediumImageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};


export type ImageMembersBySmallImageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};

/** A condition to be used against `Image` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ImageCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Image` object types. All fields are combined with a logical ‘and.’ */
export type ImageFilter = {
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberParliamentsByMediumImageId` relation. */
  memberParliamentsByMediumImageId?: InputMaybe<ImageToManyMemberParliamentFilter>;
  /** Some related `memberParliamentsByMediumImageId` exist. */
  memberParliamentsByMediumImageIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberParliamentsBySmallImageId` relation. */
  memberParliamentsBySmallImageId?: InputMaybe<ImageToManyMemberParliamentFilter>;
  /** Some related `memberParliamentsBySmallImageId` exist. */
  memberParliamentsBySmallImageIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membersByMediumImageId` relation. */
  membersByMediumImageId?: InputMaybe<ImageToManyMemberFilter>;
  /** Some related `membersByMediumImageId` exist. */
  membersByMediumImageIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membersBySmallImageId` relation. */
  membersBySmallImageId?: InputMaybe<ImageToManyMemberFilter>;
  /** Some related `membersBySmallImageId` exist. */
  membersBySmallImageIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `Member` object types. All fields are combined with a logical ‘and.’ */
export type ImageToManyMemberFilter = {
  /** Every related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberFilter>;
  /** No related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberFilter>;
  /** Some related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberFilter>;
};

/** A filter to be used against many `MemberParliament` object types. All fields are combined with a logical ‘and.’ */
export type ImageToManyMemberParliamentFilter = {
  /** Every related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberParliamentFilter>;
  /** No related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberParliamentFilter>;
  /** Some related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberParliamentFilter>;
};

/** A connection to a list of `Image` values. */
export type ImagesConnection = {
  __typename?: 'ImagesConnection';
  /** A list of edges which contains the `Image` and cursor to aid in pagination. */
  edges: Array<ImagesEdge>;
  /** A list of `Image` objects. */
  nodes: Array<Image>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Image` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Image` edge in the connection. */
export type ImagesEdge = {
  __typename?: 'ImagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Image` at the end of the edge. */
  node: Image;
};

/** Methods to use when ordering `Image`. */
export enum ImagesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PathAsc = 'PATH_ASC',
  PathDesc = 'PATH_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LegislativeAssistant = Node & {
  __typename?: 'LegislativeAssistant';
  active: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `LegislativeAssistant` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LegislativeAssistantCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `LegislativeAssistant` object types. All fields are combined with a logical ‘and.’ */
export type LegislativeAssistantFilter = {
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
};

/** A connection to a list of `LegislativeAssistant` values. */
export type LegislativeAssistantsConnection = {
  __typename?: 'LegislativeAssistantsConnection';
  /** A list of edges which contains the `LegislativeAssistant` and cursor to aid in pagination. */
  edges: Array<LegislativeAssistantsEdge>;
  /** A list of `LegislativeAssistant` objects. */
  nodes: Array<LegislativeAssistant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LegislativeAssistant` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LegislativeAssistant` edge in the connection. */
export type LegislativeAssistantsEdge = {
  __typename?: 'LegislativeAssistantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LegislativeAssistant` at the end of the edge. */
  node: LegislativeAssistant;
};

/** Methods to use when ordering `LegislativeAssistant`. */
export enum LegislativeAssistantsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type LegislatureBuilding = Node & {
  __typename?: 'LegislatureBuilding';
  active: Scalars['Boolean']['output'];
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LegislatureOffice`. */
  legislatureOfficesByBuildingId: LegislatureOfficesConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  postalcode: Scalars['String']['output'];
  province: Scalars['String']['output'];
};


export type LegislatureBuildingLegislatureOfficesByBuildingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LegislatureOfficeCondition>;
  filter?: InputMaybe<LegislatureOfficeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LegislatureOfficesOrderBy>>;
};

/**
 * A condition to be used against `LegislatureBuilding` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LegislatureBuildingCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `postalcode` field. */
  postalcode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `province` field. */
  province?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `LegislatureBuilding` object types. All fields are combined with a logical ‘and.’ */
export type LegislatureBuildingFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `legislatureOfficesByBuildingId` relation. */
  legislatureOfficesByBuildingId?: InputMaybe<LegislatureBuildingToManyLegislatureOfficeFilter>;
  /** Some related `legislatureOfficesByBuildingId` exist. */
  legislatureOfficesByBuildingIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `postalcode` field. */
  postalcode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `province` field. */
  province?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `LegislatureOffice` object types. All fields are combined with a logical ‘and.’ */
export type LegislatureBuildingToManyLegislatureOfficeFilter = {
  /** Every related `LegislatureOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LegislatureOfficeFilter>;
  /** No related `LegislatureOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LegislatureOfficeFilter>;
  /** Some related `LegislatureOffice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LegislatureOfficeFilter>;
};

/** A connection to a list of `LegislatureBuilding` values. */
export type LegislatureBuildingsConnection = {
  __typename?: 'LegislatureBuildingsConnection';
  /** A list of edges which contains the `LegislatureBuilding` and cursor to aid in pagination. */
  edges: Array<LegislatureBuildingsEdge>;
  /** A list of `LegislatureBuilding` objects. */
  nodes: Array<LegislatureBuilding>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LegislatureBuilding` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LegislatureBuilding` edge in the connection. */
export type LegislatureBuildingsEdge = {
  __typename?: 'LegislatureBuildingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LegislatureBuilding` at the end of the edge. */
  node: LegislatureBuilding;
};

/** Methods to use when ordering `LegislatureBuilding`. */
export enum LegislatureBuildingsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PostalcodeAsc = 'POSTALCODE_ASC',
  PostalcodeDesc = 'POSTALCODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProvinceAsc = 'PROVINCE_ASC',
  ProvinceDesc = 'PROVINCE_DESC'
}

export type LegislatureOffice = Node & {
  __typename?: 'LegislatureOffice';
  active: Scalars['Boolean']['output'];
  buildingId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `LegislatureBuilding` that is related to this `LegislatureOffice`. */
  legislatureBuildingByBuildingId?: Maybe<LegislatureBuilding>;
  /** Reads and enables pagination through a set of `MemberParliament`. */
  memberParliamentsByLegislativeOfficeId: MemberParliamentsConnection;
  /** Reads and enables pagination through a set of `Member`. */
  membersByLegislativeOfficeId: MembersConnection;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  roomNumber?: Maybe<Scalars['Int']['output']>;
};


export type LegislatureOfficeMemberParliamentsByLegislativeOfficeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


export type LegislatureOfficeMembersByLegislativeOfficeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};

/**
 * A condition to be used against `LegislatureOffice` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LegislatureOfficeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fax` field. */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `roomNumber` field. */
  roomNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `LegislatureOffice` object types. All fields are combined with a logical ‘and.’ */
export type LegislatureOfficeFilter = {
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fax` field. */
  fax?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `legislatureBuildingByBuildingId` relation. */
  legislatureBuildingByBuildingId?: InputMaybe<LegislatureBuildingFilter>;
  /** A related `legislatureBuildingByBuildingId` exists. */
  legislatureBuildingByBuildingIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberParliamentsByLegislativeOfficeId` relation. */
  memberParliamentsByLegislativeOfficeId?: InputMaybe<LegislatureOfficeToManyMemberParliamentFilter>;
  /** Some related `memberParliamentsByLegislativeOfficeId` exist. */
  memberParliamentsByLegislativeOfficeIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membersByLegislativeOfficeId` relation. */
  membersByLegislativeOfficeId?: InputMaybe<LegislatureOfficeToManyMemberFilter>;
  /** Some related `membersByLegislativeOfficeId` exist. */
  membersByLegislativeOfficeIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `roomNumber` field. */
  roomNumber?: InputMaybe<IntFilter>;
};

/** A filter to be used against many `Member` object types. All fields are combined with a logical ‘and.’ */
export type LegislatureOfficeToManyMemberFilter = {
  /** Every related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberFilter>;
  /** No related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberFilter>;
  /** Some related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberFilter>;
};

/** A filter to be used against many `MemberParliament` object types. All fields are combined with a logical ‘and.’ */
export type LegislatureOfficeToManyMemberParliamentFilter = {
  /** Every related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberParliamentFilter>;
  /** No related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberParliamentFilter>;
  /** Some related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberParliamentFilter>;
};

/** A connection to a list of `LegislatureOffice` values. */
export type LegislatureOfficesConnection = {
  __typename?: 'LegislatureOfficesConnection';
  /** A list of edges which contains the `LegislatureOffice` and cursor to aid in pagination. */
  edges: Array<LegislatureOfficesEdge>;
  /** A list of `LegislatureOffice` objects. */
  nodes: Array<LegislatureOffice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LegislatureOffice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LegislatureOffice` edge in the connection. */
export type LegislatureOfficesEdge = {
  __typename?: 'LegislatureOfficesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LegislatureOffice` at the end of the edge. */
  node: LegislatureOffice;
};

/** Methods to use when ordering `LegislatureOffice`. */
export enum LegislatureOfficesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FaxAsc = 'FAX_ASC',
  FaxDesc = 'FAX_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomNumberAsc = 'ROOM_NUMBER_ASC',
  RoomNumberDesc = 'ROOM_NUMBER_DESC'
}

export type Member = Node & {
  __typename?: 'Member';
  aboutMember?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `AssistantMember`. */
  assistantMembersByMemberId: AssistantMembersConnection;
  /** Reads and enables pagination through a set of `Constituency`. */
  constituenciesByMemberId: ConstituenciesConnection;
  /** Reads a single `Constituency` that is related to this `Member`. */
  constituencyByConstituencyId?: Maybe<Constituency>;
  constituencyId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `ConstituencyOffice` that is related to this `Member`. */
  constituencyOfficeByPrimaryConstituencyOfficeId?: Maybe<ConstituencyOffice>;
  dietaryRestrictions?: Maybe<Scalars['String']['output']>;
  electionYears?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ExecutiveCouncil`. */
  executiveCouncilsByMemberId: ExecutiveCouncilsConnection;
  firstName: Scalars['String']['output'];
  govEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `Image` that is related to this `Member`. */
  imageByMediumImageId?: Maybe<Image>;
  /** Reads a single `Image` that is related to this `Member`. */
  imageBySmallImageId?: Maybe<Image>;
  isCounsel: Scalars['Boolean']['output'];
  isDoctor: Scalars['Boolean']['output'];
  isHonourable: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  legislativeEmail?: Maybe<Scalars['String']['output']>;
  legislativeOfficeId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `LegislatureOffice` that is related to this `Member`. */
  legislatureOfficeByLegislativeOfficeId?: Maybe<LegislatureOffice>;
  mediumImageId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `MemberConstituency`. */
  memberConstituenciesByMemberId: MemberConstituenciesConnection;
  /** Reads and enables pagination through a set of `MemberElection`. */
  memberElectionsByMemberId: MemberElectionsConnection;
  /** Reads and enables pagination through a set of `MemberParliament`. */
  memberParliamentsByMemberId: MemberParliamentsConnection;
  /** Reads and enables pagination through a set of `MemberResignation`. */
  memberResignationsByMemberId: MemberResignationsConnection;
  /** Reads a single `MemberType` that is related to this `Member`. */
  memberTypeByMemberTypeId?: Maybe<MemberType>;
  memberTypeId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `MembersIndexLink`. */
  membersIndexLinksByMemberId: MembersIndexLinksConnection;
  middleName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Minister`. */
  ministersByMemberId: MinistersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  officePhone?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Party` that is related to this `Member`. */
  partyByPartyId?: Maybe<Party>;
  partyId: Scalars['Int']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  primaryConstituencyOfficeId?: Maybe<Scalars['Int']['output']>;
  primaryRoleId?: Maybe<Scalars['Int']['output']>;
  smallImageId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `SocialMediaLink`. */
  socialMediaLinksByMemberId: SocialMediaLinksConnection;
};


export type MemberAssistantMembersByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssistantMemberCondition>;
  filter?: InputMaybe<AssistantMemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssistantMembersOrderBy>>;
};


export type MemberConstituenciesByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConstituencyCondition>;
  filter?: InputMaybe<ConstituencyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConstituenciesOrderBy>>;
};


export type MemberExecutiveCouncilsByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ExecutiveCouncilCondition>;
  filter?: InputMaybe<ExecutiveCouncilFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExecutiveCouncilsOrderBy>>;
};


export type MemberMemberConstituenciesByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberConstituencyCondition>;
  filter?: InputMaybe<MemberConstituencyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberConstituenciesOrderBy>>;
};


export type MemberMemberElectionsByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberElectionCondition>;
  filter?: InputMaybe<MemberElectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberElectionsOrderBy>>;
};


export type MemberMemberParliamentsByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


export type MemberMemberResignationsByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberResignationCondition>;
  filter?: InputMaybe<MemberResignationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberResignationsOrderBy>>;
};


export type MemberMembersIndexLinksByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembersIndexLinkCondition>;
  filter?: InputMaybe<MembersIndexLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersIndexLinksOrderBy>>;
};


export type MemberMinistersByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MinisterCondition>;
  filter?: InputMaybe<MinisterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MinistersOrderBy>>;
};


export type MemberSocialMediaLinksByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SocialMediaLinkCondition>;
  filter?: InputMaybe<SocialMediaLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SocialMediaLinksOrderBy>>;
};

/** A condition to be used against `Member` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MemberCondition = {
  /** Checks for equality with the object’s `aboutMember` field. */
  aboutMember?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dietaryRestrictions` field. */
  dietaryRestrictions?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `electionYears` field. */
  electionYears?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `govEmail` field. */
  govEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isCounsel` field. */
  isCounsel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isDoctor` field. */
  isDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isHonourable` field. */
  isHonourable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `legislativeEmail` field. */
  legislativeEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `legislativeOfficeId` field. */
  legislativeOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `mediumImageId` field. */
  mediumImageId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberTypeId` field. */
  memberTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `middleName` field. */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `officePhone` field. */
  officePhone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `partyId` field. */
  partyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `prefix` field. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `primaryConstituencyOfficeId` field. */
  primaryConstituencyOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `primaryRoleId` field. */
  primaryRoleId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `smallImageId` field. */
  smallImageId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `MemberConstituency` values. */
export type MemberConstituenciesConnection = {
  __typename?: 'MemberConstituenciesConnection';
  /** A list of edges which contains the `MemberConstituency` and cursor to aid in pagination. */
  edges: Array<MemberConstituenciesEdge>;
  /** A list of `MemberConstituency` objects. */
  nodes: Array<MemberConstituency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberConstituency` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberConstituency` edge in the connection. */
export type MemberConstituenciesEdge = {
  __typename?: 'MemberConstituenciesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberConstituency` at the end of the edge. */
  node: MemberConstituency;
};

/** Methods to use when ordering `MemberConstituency`. */
export enum MemberConstituenciesOrderBy {
  ConstituencyOfficeIdAsc = 'CONSTITUENCY_OFFICE_ID_ASC',
  ConstituencyOfficeIdDesc = 'CONSTITUENCY_OFFICE_ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL'
}

export type MemberConstituency = {
  __typename?: 'MemberConstituency';
  /** Reads a single `ConstituencyOffice` that is related to this `MemberConstituency`. */
  constituencyOfficeByConstituencyOfficeId?: Maybe<ConstituencyOffice>;
  constituencyOfficeId: Scalars['Int']['output'];
  /** Reads a single `Member` that is related to this `MemberConstituency`. */
  memberByMemberId?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `MemberConstituency` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MemberConstituencyCondition = {
  /** Checks for equality with the object’s `constituencyOfficeId` field. */
  constituencyOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `MemberConstituency` object types. All fields are combined with a logical ‘and.’ */
export type MemberConstituencyFilter = {
  /** Filter by the object’s `constituencyOfficeByConstituencyOfficeId` relation. */
  constituencyOfficeByConstituencyOfficeId?: InputMaybe<ConstituencyOfficeFilter>;
  /** Filter by the object’s `constituencyOfficeId` field. */
  constituencyOfficeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
};

export type MemberElection = Node & {
  __typename?: 'MemberElection';
  /** Reads a single `Constituency` that is related to this `MemberElection`. */
  constituencyByConstituencyId?: Maybe<Constituency>;
  constituencyId?: Maybe<Scalars['Int']['output']>;
  electionDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `Member` that is related to this `MemberElection`. */
  memberByMemberId?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Party` that is related to this `MemberElection`. */
  partyByPartyId?: Maybe<Party>;
  partyId?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `MemberElection` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MemberElectionCondition = {
  /** Checks for equality with the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `electionDate` field. */
  electionDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `partyId` field. */
  partyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MemberElection` object types. All fields are combined with a logical ‘and.’ */
export type MemberElectionFilter = {
  /** Filter by the object’s `constituencyByConstituencyId` relation. */
  constituencyByConstituencyId?: InputMaybe<ConstituencyFilter>;
  /** A related `constituencyByConstituencyId` exists. */
  constituencyByConstituencyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `partyByPartyId` relation. */
  partyByPartyId?: InputMaybe<PartyFilter>;
  /** A related `partyByPartyId` exists. */
  partyByPartyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `partyId` field. */
  partyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<StringFilter>;
};

/** A connection to a list of `MemberElection` values. */
export type MemberElectionsConnection = {
  __typename?: 'MemberElectionsConnection';
  /** A list of edges which contains the `MemberElection` and cursor to aid in pagination. */
  edges: Array<MemberElectionsEdge>;
  /** A list of `MemberElection` objects. */
  nodes: Array<MemberElection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberElection` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberElection` edge in the connection. */
export type MemberElectionsEdge = {
  __typename?: 'MemberElectionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberElection` at the end of the edge. */
  node: MemberElection;
};

/** Methods to use when ordering `MemberElection`. */
export enum MemberElectionsOrderBy {
  ConstituencyIdAsc = 'CONSTITUENCY_ID_ASC',
  ConstituencyIdDesc = 'CONSTITUENCY_ID_DESC',
  ElectionDateAsc = 'ELECTION_DATE_ASC',
  ElectionDateDesc = 'ELECTION_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PartyIdAsc = 'PARTY_ID_ASC',
  PartyIdDesc = 'PARTY_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

/** A filter to be used against `Member` object types. All fields are combined with a logical ‘and.’ */
export type MemberFilter = {
  /** Filter by the object’s `aboutMember` field. */
  aboutMember?: InputMaybe<StringFilter>;
  /** Filter by the object’s `assistantMembersByMemberId` relation. */
  assistantMembersByMemberId?: InputMaybe<MemberToManyAssistantMemberFilter>;
  /** Some related `assistantMembersByMemberId` exist. */
  assistantMembersByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `constituenciesByMemberId` relation. */
  constituenciesByMemberId?: InputMaybe<MemberToManyConstituencyFilter>;
  /** Some related `constituenciesByMemberId` exist. */
  constituenciesByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `constituencyByConstituencyId` relation. */
  constituencyByConstituencyId?: InputMaybe<ConstituencyFilter>;
  /** A related `constituencyByConstituencyId` exists. */
  constituencyByConstituencyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `constituencyOfficeByPrimaryConstituencyOfficeId` relation. */
  constituencyOfficeByPrimaryConstituencyOfficeId?: InputMaybe<ConstituencyOfficeFilter>;
  /** A related `constituencyOfficeByPrimaryConstituencyOfficeId` exists. */
  constituencyOfficeByPrimaryConstituencyOfficeIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `dietaryRestrictions` field. */
  dietaryRestrictions?: InputMaybe<StringFilter>;
  /** Filter by the object’s `electionYears` field. */
  electionYears?: InputMaybe<StringFilter>;
  /** Filter by the object’s `executiveCouncilsByMemberId` relation. */
  executiveCouncilsByMemberId?: InputMaybe<MemberToManyExecutiveCouncilFilter>;
  /** Some related `executiveCouncilsByMemberId` exist. */
  executiveCouncilsByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `govEmail` field. */
  govEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `imageByMediumImageId` relation. */
  imageByMediumImageId?: InputMaybe<ImageFilter>;
  /** A related `imageByMediumImageId` exists. */
  imageByMediumImageIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `imageBySmallImageId` relation. */
  imageBySmallImageId?: InputMaybe<ImageFilter>;
  /** A related `imageBySmallImageId` exists. */
  imageBySmallImageIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `legislativeEmail` field. */
  legislativeEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `legislativeOfficeId` field. */
  legislativeOfficeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `legislatureOfficeByLegislativeOfficeId` relation. */
  legislatureOfficeByLegislativeOfficeId?: InputMaybe<LegislatureOfficeFilter>;
  /** A related `legislatureOfficeByLegislativeOfficeId` exists. */
  legislatureOfficeByLegislativeOfficeIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `mediumImageId` field. */
  mediumImageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberConstituenciesByMemberId` relation. */
  memberConstituenciesByMemberId?: InputMaybe<MemberToManyMemberConstituencyFilter>;
  /** Some related `memberConstituenciesByMemberId` exist. */
  memberConstituenciesByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberElectionsByMemberId` relation. */
  memberElectionsByMemberId?: InputMaybe<MemberToManyMemberElectionFilter>;
  /** Some related `memberElectionsByMemberId` exist. */
  memberElectionsByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberParliamentsByMemberId` relation. */
  memberParliamentsByMemberId?: InputMaybe<MemberToManyMemberParliamentFilter>;
  /** Some related `memberParliamentsByMemberId` exist. */
  memberParliamentsByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberResignationsByMemberId` relation. */
  memberResignationsByMemberId?: InputMaybe<MemberToManyMemberResignationFilter>;
  /** Some related `memberResignationsByMemberId` exist. */
  memberResignationsByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberTypeByMemberTypeId` relation. */
  memberTypeByMemberTypeId?: InputMaybe<MemberTypeFilter>;
  /** A related `memberTypeByMemberTypeId` exists. */
  memberTypeByMemberTypeIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberTypeId` field. */
  memberTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `membersIndexLinksByMemberId` relation. */
  membersIndexLinksByMemberId?: InputMaybe<MemberToManyMembersIndexLinkFilter>;
  /** Some related `membersIndexLinksByMemberId` exist. */
  membersIndexLinksByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `middleName` field. */
  middleName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ministersByMemberId` relation. */
  ministersByMemberId?: InputMaybe<MemberToManyMinisterFilter>;
  /** Some related `ministersByMemberId` exist. */
  ministersByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `officePhone` field. */
  officePhone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `partyByPartyId` relation. */
  partyByPartyId?: InputMaybe<PartyFilter>;
  /** Filter by the object’s `partyId` field. */
  partyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `prefix` field. */
  prefix?: InputMaybe<StringFilter>;
  /** Filter by the object’s `primaryConstituencyOfficeId` field. */
  primaryConstituencyOfficeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `primaryRoleId` field. */
  primaryRoleId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `smallImageId` field. */
  smallImageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `socialMediaLinksByMemberId` relation. */
  socialMediaLinksByMemberId?: InputMaybe<MemberToManySocialMediaLinkFilter>;
  /** Some related `socialMediaLinksByMemberId` exist. */
  socialMediaLinksByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberParliament = Node & {
  __typename?: 'MemberParliament';
  aboutMember?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  /** Reads a single `Constituency` that is related to this `MemberParliament`. */
  constituencyByConstituencyId?: Maybe<Constituency>;
  constituencyId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `ConstituencyOffice` that is related to this `MemberParliament`. */
  constituencyOfficeByPrimaryConstituencyOfficeId?: Maybe<ConstituencyOffice>;
  govEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `Image` that is related to this `MemberParliament`. */
  imageByMediumImageId?: Maybe<Image>;
  /** Reads a single `Image` that is related to this `MemberParliament`. */
  imageBySmallImageId?: Maybe<Image>;
  isCounsel: Scalars['Boolean']['output'];
  isDoctor: Scalars['Boolean']['output'];
  isHonourable: Scalars['Boolean']['output'];
  legislativeEmail?: Maybe<Scalars['String']['output']>;
  legislativeOfficeId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `LegislatureOffice` that is related to this `MemberParliament`. */
  legislatureOfficeByLegislativeOfficeId?: Maybe<LegislatureOffice>;
  mediumImageId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Member` that is related to this `MemberParliament`. */
  memberByMemberId?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `MemberRole`. */
  memberRolesByMemberParliamentId: MemberRolesConnection;
  /** Reads a single `MemberType` that is related to this `MemberParliament`. */
  memberTypeByMemberTypeId?: Maybe<MemberType>;
  memberTypeId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `MembersIndexLink`. */
  membersIndexLinksByMemberParliamentId: MembersIndexLinksConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  officePhone?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Parliament` that is related to this `MemberParliament`. */
  parliamentByParliamentId?: Maybe<Parliament>;
  parliamentId: Scalars['Int']['output'];
  /** Reads a single `Party` that is related to this `MemberParliament`. */
  partyByPartyId?: Maybe<Party>;
  partyId?: Maybe<Scalars['Int']['output']>;
  primaryConstituencyOfficeId?: Maybe<Scalars['Int']['output']>;
  primaryRoleId?: Maybe<Scalars['Int']['output']>;
  smallImageId?: Maybe<Scalars['Int']['output']>;
};


export type MemberParliamentMemberRolesByMemberParliamentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberRoleCondition>;
  filter?: InputMaybe<MemberRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberRolesOrderBy>>;
};


export type MemberParliamentMembersIndexLinksByMemberParliamentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembersIndexLinkCondition>;
  filter?: InputMaybe<MembersIndexLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersIndexLinksOrderBy>>;
};

/**
 * A condition to be used against `MemberParliament` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MemberParliamentCondition = {
  /** Checks for equality with the object’s `aboutMember` field. */
  aboutMember?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `govEmail` field. */
  govEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isCounsel` field. */
  isCounsel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isDoctor` field. */
  isDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isHonourable` field. */
  isHonourable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `legislativeEmail` field. */
  legislativeEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `legislativeOfficeId` field. */
  legislativeOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `mediumImageId` field. */
  mediumImageId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberTypeId` field. */
  memberTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `officePhone` field. */
  officePhone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `parliamentId` field. */
  parliamentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `partyId` field. */
  partyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `primaryConstituencyOfficeId` field. */
  primaryConstituencyOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `primaryRoleId` field. */
  primaryRoleId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `smallImageId` field. */
  smallImageId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `MemberParliament` object types. All fields are combined with a logical ‘and.’ */
export type MemberParliamentFilter = {
  /** Filter by the object’s `aboutMember` field. */
  aboutMember?: InputMaybe<StringFilter>;
  /** Filter by the object’s `constituencyByConstituencyId` relation. */
  constituencyByConstituencyId?: InputMaybe<ConstituencyFilter>;
  /** A related `constituencyByConstituencyId` exists. */
  constituencyByConstituencyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `constituencyOfficeByPrimaryConstituencyOfficeId` relation. */
  constituencyOfficeByPrimaryConstituencyOfficeId?: InputMaybe<ConstituencyOfficeFilter>;
  /** A related `constituencyOfficeByPrimaryConstituencyOfficeId` exists. */
  constituencyOfficeByPrimaryConstituencyOfficeIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `govEmail` field. */
  govEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `imageByMediumImageId` relation. */
  imageByMediumImageId?: InputMaybe<ImageFilter>;
  /** A related `imageByMediumImageId` exists. */
  imageByMediumImageIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `imageBySmallImageId` relation. */
  imageBySmallImageId?: InputMaybe<ImageFilter>;
  /** A related `imageBySmallImageId` exists. */
  imageBySmallImageIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `legislativeEmail` field. */
  legislativeEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `legislativeOfficeId` field. */
  legislativeOfficeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `legislatureOfficeByLegislativeOfficeId` relation. */
  legislatureOfficeByLegislativeOfficeId?: InputMaybe<LegislatureOfficeFilter>;
  /** A related `legislatureOfficeByLegislativeOfficeId` exists. */
  legislatureOfficeByLegislativeOfficeIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `mediumImageId` field. */
  mediumImageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberRolesByMemberParliamentId` relation. */
  memberRolesByMemberParliamentId?: InputMaybe<MemberParliamentToManyMemberRoleFilter>;
  /** Some related `memberRolesByMemberParliamentId` exist. */
  memberRolesByMemberParliamentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberTypeByMemberTypeId` relation. */
  memberTypeByMemberTypeId?: InputMaybe<MemberTypeFilter>;
  /** A related `memberTypeByMemberTypeId` exists. */
  memberTypeByMemberTypeIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberTypeId` field. */
  memberTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `membersIndexLinksByMemberParliamentId` relation. */
  membersIndexLinksByMemberParliamentId?: InputMaybe<MemberParliamentToManyMembersIndexLinkFilter>;
  /** Some related `membersIndexLinksByMemberParliamentId` exist. */
  membersIndexLinksByMemberParliamentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `officePhone` field. */
  officePhone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `parliamentByParliamentId` relation. */
  parliamentByParliamentId?: InputMaybe<ParliamentFilter>;
  /** Filter by the object’s `parliamentId` field. */
  parliamentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `partyByPartyId` relation. */
  partyByPartyId?: InputMaybe<PartyFilter>;
  /** A related `partyByPartyId` exists. */
  partyByPartyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `partyId` field. */
  partyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `primaryConstituencyOfficeId` field. */
  primaryConstituencyOfficeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `primaryRoleId` field. */
  primaryRoleId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `smallImageId` field. */
  smallImageId?: InputMaybe<IntFilter>;
};

/** A filter to be used against many `MemberRole` object types. All fields are combined with a logical ‘and.’ */
export type MemberParliamentToManyMemberRoleFilter = {
  /** Every related `MemberRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberRoleFilter>;
  /** No related `MemberRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberRoleFilter>;
  /** Some related `MemberRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberRoleFilter>;
};

/** A filter to be used against many `MembersIndexLink` object types. All fields are combined with a logical ‘and.’ */
export type MemberParliamentToManyMembersIndexLinkFilter = {
  /** Every related `MembersIndexLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembersIndexLinkFilter>;
  /** No related `MembersIndexLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembersIndexLinkFilter>;
  /** Some related `MembersIndexLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembersIndexLinkFilter>;
};

/** A connection to a list of `MemberParliament` values. */
export type MemberParliamentsConnection = {
  __typename?: 'MemberParliamentsConnection';
  /** A list of edges which contains the `MemberParliament` and cursor to aid in pagination. */
  edges: Array<MemberParliamentsEdge>;
  /** A list of `MemberParliament` objects. */
  nodes: Array<MemberParliament>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberParliament` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberParliament` edge in the connection. */
export type MemberParliamentsEdge = {
  __typename?: 'MemberParliamentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberParliament` at the end of the edge. */
  node: MemberParliament;
};

/** Methods to use when ordering `MemberParliament`. */
export enum MemberParliamentsOrderBy {
  AboutMemberAsc = 'ABOUT_MEMBER_ASC',
  AboutMemberDesc = 'ABOUT_MEMBER_DESC',
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  ConstituencyIdAsc = 'CONSTITUENCY_ID_ASC',
  ConstituencyIdDesc = 'CONSTITUENCY_ID_DESC',
  GovEmailAsc = 'GOV_EMAIL_ASC',
  GovEmailDesc = 'GOV_EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCounselAsc = 'IS_COUNSEL_ASC',
  IsCounselDesc = 'IS_COUNSEL_DESC',
  IsDoctorAsc = 'IS_DOCTOR_ASC',
  IsDoctorDesc = 'IS_DOCTOR_DESC',
  IsHonourableAsc = 'IS_HONOURABLE_ASC',
  IsHonourableDesc = 'IS_HONOURABLE_DESC',
  LegislativeEmailAsc = 'LEGISLATIVE_EMAIL_ASC',
  LegislativeEmailDesc = 'LEGISLATIVE_EMAIL_DESC',
  LegislativeOfficeIdAsc = 'LEGISLATIVE_OFFICE_ID_ASC',
  LegislativeOfficeIdDesc = 'LEGISLATIVE_OFFICE_ID_DESC',
  MediumImageIdAsc = 'MEDIUM_IMAGE_ID_ASC',
  MediumImageIdDesc = 'MEDIUM_IMAGE_ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  MemberTypeIdAsc = 'MEMBER_TYPE_ID_ASC',
  MemberTypeIdDesc = 'MEMBER_TYPE_ID_DESC',
  Natural = 'NATURAL',
  OfficePhoneAsc = 'OFFICE_PHONE_ASC',
  OfficePhoneDesc = 'OFFICE_PHONE_DESC',
  ParliamentIdAsc = 'PARLIAMENT_ID_ASC',
  ParliamentIdDesc = 'PARLIAMENT_ID_DESC',
  PartyIdAsc = 'PARTY_ID_ASC',
  PartyIdDesc = 'PARTY_ID_DESC',
  PrimaryConstituencyOfficeIdAsc = 'PRIMARY_CONSTITUENCY_OFFICE_ID_ASC',
  PrimaryConstituencyOfficeIdDesc = 'PRIMARY_CONSTITUENCY_OFFICE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PrimaryRoleIdAsc = 'PRIMARY_ROLE_ID_ASC',
  PrimaryRoleIdDesc = 'PRIMARY_ROLE_ID_DESC',
  SmallImageIdAsc = 'SMALL_IMAGE_ID_ASC',
  SmallImageIdDesc = 'SMALL_IMAGE_ID_DESC'
}

export type MemberResignation = Node & {
  __typename?: 'MemberResignation';
  id: Scalars['Int']['output'];
  /** Reads a single `Member` that is related to this `MemberResignation`. */
  memberByMemberId?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  resignationDate?: Maybe<Scalars['Date']['output']>;
};

/**
 * A condition to be used against `MemberResignation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MemberResignationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `resignationDate` field. */
  resignationDate?: InputMaybe<Scalars['Date']['input']>;
};

/** A filter to be used against `MemberResignation` object types. All fields are combined with a logical ‘and.’ */
export type MemberResignationFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `MemberResignation` values. */
export type MemberResignationsConnection = {
  __typename?: 'MemberResignationsConnection';
  /** A list of edges which contains the `MemberResignation` and cursor to aid in pagination. */
  edges: Array<MemberResignationsEdge>;
  /** A list of `MemberResignation` objects. */
  nodes: Array<MemberResignation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberResignation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberResignation` edge in the connection. */
export type MemberResignationsEdge = {
  __typename?: 'MemberResignationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberResignation` at the end of the edge. */
  node: MemberResignation;
};

/** Methods to use when ordering `MemberResignation`. */
export enum MemberResignationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResignationDateAsc = 'RESIGNATION_DATE_ASC',
  ResignationDateDesc = 'RESIGNATION_DATE_DESC'
}

export type MemberRole = Node & {
  __typename?: 'MemberRole';
  active: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `MemberParliament` that is related to this `MemberRole`. */
  memberParliamentByMemberParliamentId?: Maybe<MemberParliament>;
  memberParliamentId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Role` that is related to this `MemberRole`. */
  roleByRoleId?: Maybe<Role>;
  roleId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
};

/**
 * A condition to be used against `MemberRole` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MemberRoleCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberParliamentId` field. */
  memberParliamentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** A filter to be used against `MemberRole` object types. All fields are combined with a logical ‘and.’ */
export type MemberRoleFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberParliamentByMemberParliamentId` relation. */
  memberParliamentByMemberParliamentId?: InputMaybe<MemberParliamentFilter>;
  /** Filter by the object’s `memberParliamentId` field. */
  memberParliamentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `roleByRoleId` relation. */
  roleByRoleId?: InputMaybe<RoleFilter>;
  /** Filter by the object’s `roleId` field. */
  roleId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `MemberRole` values. */
export type MemberRolesConnection = {
  __typename?: 'MemberRolesConnection';
  /** A list of edges which contains the `MemberRole` and cursor to aid in pagination. */
  edges: Array<MemberRolesEdge>;
  /** A list of `MemberRole` objects. */
  nodes: Array<MemberRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberRole` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberRole` edge in the connection. */
export type MemberRolesEdge = {
  __typename?: 'MemberRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberRole` at the end of the edge. */
  node: MemberRole;
};

/** Methods to use when ordering `MemberRole`. */
export enum MemberRolesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberParliamentIdAsc = 'MEMBER_PARLIAMENT_ID_ASC',
  MemberParliamentIdDesc = 'MEMBER_PARLIAMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleIdAsc = 'ROLE_ID_ASC',
  RoleIdDesc = 'ROLE_ID_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

/** A filter to be used against many `AssistantMember` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyAssistantMemberFilter = {
  /** Every related `AssistantMember` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssistantMemberFilter>;
  /** No related `AssistantMember` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssistantMemberFilter>;
  /** Some related `AssistantMember` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssistantMemberFilter>;
};

/** A filter to be used against many `Constituency` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyConstituencyFilter = {
  /** Every related `Constituency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ConstituencyFilter>;
  /** No related `Constituency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ConstituencyFilter>;
  /** Some related `Constituency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ConstituencyFilter>;
};

/** A filter to be used against many `ExecutiveCouncil` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyExecutiveCouncilFilter = {
  /** Every related `ExecutiveCouncil` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExecutiveCouncilFilter>;
  /** No related `ExecutiveCouncil` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExecutiveCouncilFilter>;
  /** Some related `ExecutiveCouncil` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExecutiveCouncilFilter>;
};

/** A filter to be used against many `MemberConstituency` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyMemberConstituencyFilter = {
  /** Every related `MemberConstituency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberConstituencyFilter>;
  /** No related `MemberConstituency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberConstituencyFilter>;
  /** Some related `MemberConstituency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberConstituencyFilter>;
};

/** A filter to be used against many `MemberElection` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyMemberElectionFilter = {
  /** Every related `MemberElection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberElectionFilter>;
  /** No related `MemberElection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberElectionFilter>;
  /** Some related `MemberElection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberElectionFilter>;
};

/** A filter to be used against many `MemberParliament` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyMemberParliamentFilter = {
  /** Every related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberParliamentFilter>;
  /** No related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberParliamentFilter>;
  /** Some related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberParliamentFilter>;
};

/** A filter to be used against many `MemberResignation` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyMemberResignationFilter = {
  /** Every related `MemberResignation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberResignationFilter>;
  /** No related `MemberResignation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberResignationFilter>;
  /** Some related `MemberResignation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberResignationFilter>;
};

/** A filter to be used against many `MembersIndexLink` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyMembersIndexLinkFilter = {
  /** Every related `MembersIndexLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembersIndexLinkFilter>;
  /** No related `MembersIndexLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembersIndexLinkFilter>;
  /** Some related `MembersIndexLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembersIndexLinkFilter>;
};

/** A filter to be used against many `Minister` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyMinisterFilter = {
  /** Every related `Minister` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MinisterFilter>;
  /** No related `Minister` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MinisterFilter>;
  /** Some related `Minister` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MinisterFilter>;
};

/** A filter to be used against many `SocialMediaLink` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManySocialMediaLinkFilter = {
  /** Every related `SocialMediaLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SocialMediaLinkFilter>;
  /** No related `SocialMediaLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SocialMediaLinkFilter>;
  /** Some related `SocialMediaLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SocialMediaLinkFilter>;
};

export type MemberType = Node & {
  __typename?: 'MemberType';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `MemberParliament`. */
  memberParliamentsByMemberTypeId: MemberParliamentsConnection;
  /** Reads and enables pagination through a set of `Member`. */
  membersByMemberTypeId: MembersConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type MemberTypeMemberParliamentsByMemberTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


export type MemberTypeMembersByMemberTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};

/**
 * A condition to be used against `MemberType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MemberTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MemberType` object types. All fields are combined with a logical ‘and.’ */
export type MemberTypeFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberParliamentsByMemberTypeId` relation. */
  memberParliamentsByMemberTypeId?: InputMaybe<MemberTypeToManyMemberParliamentFilter>;
  /** Some related `memberParliamentsByMemberTypeId` exist. */
  memberParliamentsByMemberTypeIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membersByMemberTypeId` relation. */
  membersByMemberTypeId?: InputMaybe<MemberTypeToManyMemberFilter>;
  /** Some related `membersByMemberTypeId` exist. */
  membersByMemberTypeIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `Member` object types. All fields are combined with a logical ‘and.’ */
export type MemberTypeToManyMemberFilter = {
  /** Every related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberFilter>;
  /** No related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberFilter>;
  /** Some related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberFilter>;
};

/** A filter to be used against many `MemberParliament` object types. All fields are combined with a logical ‘and.’ */
export type MemberTypeToManyMemberParliamentFilter = {
  /** Every related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberParliamentFilter>;
  /** No related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberParliamentFilter>;
  /** Some related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberParliamentFilter>;
};

/** A connection to a list of `MemberType` values. */
export type MemberTypesConnection = {
  __typename?: 'MemberTypesConnection';
  /** A list of edges which contains the `MemberType` and cursor to aid in pagination. */
  edges: Array<MemberTypesEdge>;
  /** A list of `MemberType` objects. */
  nodes: Array<MemberType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberType` edge in the connection. */
export type MemberTypesEdge = {
  __typename?: 'MemberTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberType` at the end of the edge. */
  node: MemberType;
};

/** Methods to use when ordering `MemberType`. */
export enum MemberTypesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Member` values. */
export type MembersConnection = {
  __typename?: 'MembersConnection';
  /** A list of edges which contains the `Member` and cursor to aid in pagination. */
  edges: Array<MembersEdge>;
  /** A list of `Member` objects. */
  nodes: Array<Member>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Member` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Member` edge in the connection. */
export type MembersEdge = {
  __typename?: 'MembersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Member` at the end of the edge. */
  node: Member;
};

export type MembersIndexLink = Node & {
  __typename?: 'MembersIndexLink';
  id: Scalars['Int']['output'];
  linkPath: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `MembersIndexLink`. */
  memberByMemberId?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  /** Reads a single `MemberParliament` that is related to this `MembersIndexLink`. */
  memberParliamentByMemberParliamentId?: Maybe<MemberParliament>;
  memberParliamentId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/**
 * A condition to be used against `MembersIndexLink` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MembersIndexLinkCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `linkPath` field. */
  linkPath?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memberParliamentId` field. */
  memberParliamentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MembersIndexLink` object types. All fields are combined with a logical ‘and.’ */
export type MembersIndexLinkFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `linkPath` field. */
  linkPath?: InputMaybe<StringFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberParliamentByMemberParliamentId` relation. */
  memberParliamentByMemberParliamentId?: InputMaybe<MemberParliamentFilter>;
  /** A related `memberParliamentByMemberParliamentId` exists. */
  memberParliamentByMemberParliamentIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberParliamentId` field. */
  memberParliamentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
};

/** A connection to a list of `MembersIndexLink` values. */
export type MembersIndexLinksConnection = {
  __typename?: 'MembersIndexLinksConnection';
  /** A list of edges which contains the `MembersIndexLink` and cursor to aid in pagination. */
  edges: Array<MembersIndexLinksEdge>;
  /** A list of `MembersIndexLink` objects. */
  nodes: Array<MembersIndexLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MembersIndexLink` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MembersIndexLink` edge in the connection. */
export type MembersIndexLinksEdge = {
  __typename?: 'MembersIndexLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MembersIndexLink` at the end of the edge. */
  node: MembersIndexLink;
};

/** Methods to use when ordering `MembersIndexLink`. */
export enum MembersIndexLinksOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LinkPathAsc = 'LINK_PATH_ASC',
  LinkPathDesc = 'LINK_PATH_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  MemberParliamentIdAsc = 'MEMBER_PARLIAMENT_ID_ASC',
  MemberParliamentIdDesc = 'MEMBER_PARLIAMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** Methods to use when ordering `Member`. */
export enum MembersOrderBy {
  AboutMemberAsc = 'ABOUT_MEMBER_ASC',
  AboutMemberDesc = 'ABOUT_MEMBER_DESC',
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  ConstituencyIdAsc = 'CONSTITUENCY_ID_ASC',
  ConstituencyIdDesc = 'CONSTITUENCY_ID_DESC',
  DietaryRestrictionsAsc = 'DIETARY_RESTRICTIONS_ASC',
  DietaryRestrictionsDesc = 'DIETARY_RESTRICTIONS_DESC',
  ElectionYearsAsc = 'ELECTION_YEARS_ASC',
  ElectionYearsDesc = 'ELECTION_YEARS_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  GovEmailAsc = 'GOV_EMAIL_ASC',
  GovEmailDesc = 'GOV_EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCounselAsc = 'IS_COUNSEL_ASC',
  IsCounselDesc = 'IS_COUNSEL_DESC',
  IsDoctorAsc = 'IS_DOCTOR_ASC',
  IsDoctorDesc = 'IS_DOCTOR_DESC',
  IsHonourableAsc = 'IS_HONOURABLE_ASC',
  IsHonourableDesc = 'IS_HONOURABLE_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  LegislativeEmailAsc = 'LEGISLATIVE_EMAIL_ASC',
  LegislativeEmailDesc = 'LEGISLATIVE_EMAIL_DESC',
  LegislativeOfficeIdAsc = 'LEGISLATIVE_OFFICE_ID_ASC',
  LegislativeOfficeIdDesc = 'LEGISLATIVE_OFFICE_ID_DESC',
  MediumImageIdAsc = 'MEDIUM_IMAGE_ID_ASC',
  MediumImageIdDesc = 'MEDIUM_IMAGE_ID_DESC',
  MemberTypeIdAsc = 'MEMBER_TYPE_ID_ASC',
  MemberTypeIdDesc = 'MEMBER_TYPE_ID_DESC',
  MiddleNameAsc = 'MIDDLE_NAME_ASC',
  MiddleNameDesc = 'MIDDLE_NAME_DESC',
  Natural = 'NATURAL',
  OfficePhoneAsc = 'OFFICE_PHONE_ASC',
  OfficePhoneDesc = 'OFFICE_PHONE_DESC',
  PartyIdAsc = 'PARTY_ID_ASC',
  PartyIdDesc = 'PARTY_ID_DESC',
  PrefixAsc = 'PREFIX_ASC',
  PrefixDesc = 'PREFIX_DESC',
  PrimaryConstituencyOfficeIdAsc = 'PRIMARY_CONSTITUENCY_OFFICE_ID_ASC',
  PrimaryConstituencyOfficeIdDesc = 'PRIMARY_CONSTITUENCY_OFFICE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PrimaryRoleIdAsc = 'PRIMARY_ROLE_ID_ASC',
  PrimaryRoleIdDesc = 'PRIMARY_ROLE_ID_DESC',
  SmallImageIdAsc = 'SMALL_IMAGE_ID_ASC',
  SmallImageIdDesc = 'SMALL_IMAGE_ID_DESC'
}

export type Minister = Node & {
  __typename?: 'Minister';
  active: Scalars['Boolean']['output'];
  details?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isCouncil: Scalars['Boolean']['output'];
  /** Reads a single `Member` that is related to this `Minister`. */
  memberByMemberId?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/**
 * A condition to be used against `Minister` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MinisterCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isCouncil` field. */
  isCouncil?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Minister` object types. All fields are combined with a logical ‘and.’ */
export type MinisterFilter = {
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** A related `memberByMemberId` exists. */
  memberByMemberIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
};

/** A connection to a list of `Minister` values. */
export type MinistersConnection = {
  __typename?: 'MinistersConnection';
  /** A list of edges which contains the `Minister` and cursor to aid in pagination. */
  edges: Array<MinistersEdge>;
  /** A list of `Minister` objects. */
  nodes: Array<Minister>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Minister` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Minister` edge in the connection. */
export type MinistersEdge = {
  __typename?: 'MinistersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Minister` at the end of the edge. */
  node: Minister;
};

/** Methods to use when ordering `Minister`. */
export enum MinistersOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCouncilAsc = 'IS_COUNCIL_ASC',
  IsCouncilDesc = 'IS_COUNCIL_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Parliament = Node & {
  __typename?: 'Parliament';
  active: Scalars['Boolean']['output'];
  annotation?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `MemberParliament`. */
  memberParliamentsByParliamentId: MemberParliamentsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Session`. */
  sessionsByParliamentId: SessionsConnection;
  startDate?: Maybe<Scalars['Date']['output']>;
};


export type ParliamentMemberParliamentsByParliamentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


export type ParliamentSessionsByParliamentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SessionCondition>;
  filter?: InputMaybe<SessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SessionsOrderBy>>;
};

/**
 * A condition to be used against `Parliament` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ParliamentCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `annotation` field. */
  annotation?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `number` field. */
  number?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** A filter to be used against `Parliament` object types. All fields are combined with a logical ‘and.’ */
export type ParliamentFilter = {
  /** Filter by the object’s `annotation` field. */
  annotation?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberParliamentsByParliamentId` relation. */
  memberParliamentsByParliamentId?: InputMaybe<ParliamentToManyMemberParliamentFilter>;
  /** Some related `memberParliamentsByParliamentId` exist. */
  memberParliamentsByParliamentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `number` field. */
  number?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sessionsByParliamentId` relation. */
  sessionsByParliamentId?: InputMaybe<ParliamentToManySessionFilter>;
  /** Some related `sessionsByParliamentId` exist. */
  sessionsByParliamentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against many `MemberParliament` object types. All fields are combined with a logical ‘and.’ */
export type ParliamentToManyMemberParliamentFilter = {
  /** Every related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberParliamentFilter>;
  /** No related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberParliamentFilter>;
  /** Some related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberParliamentFilter>;
};

/** A filter to be used against many `Session` object types. All fields are combined with a logical ‘and.’ */
export type ParliamentToManySessionFilter = {
  /** Every related `Session` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SessionFilter>;
  /** No related `Session` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SessionFilter>;
  /** Some related `Session` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SessionFilter>;
};

/** A connection to a list of `Parliament` values. */
export type ParliamentsConnection = {
  __typename?: 'ParliamentsConnection';
  /** A list of edges which contains the `Parliament` and cursor to aid in pagination. */
  edges: Array<ParliamentsEdge>;
  /** A list of `Parliament` objects. */
  nodes: Array<Parliament>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Parliament` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Parliament` edge in the connection. */
export type ParliamentsEdge = {
  __typename?: 'ParliamentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Parliament` at the end of the edge. */
  node: Parliament;
};

/** Methods to use when ordering `Parliament`. */
export enum ParliamentsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  AnnotationAsc = 'ANNOTATION_ASC',
  AnnotationDesc = 'ANNOTATION_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

/** A connection to a list of `Party` values. */
export type PartiesConnection = {
  __typename?: 'PartiesConnection';
  /** A list of edges which contains the `Party` and cursor to aid in pagination. */
  edges: Array<PartiesEdge>;
  /** A list of `Party` objects. */
  nodes: Array<Party>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Party` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Party` edge in the connection. */
export type PartiesEdge = {
  __typename?: 'PartiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Party` at the end of the edge. */
  node: Party;
};

/** Methods to use when ordering `Party`. */
export enum PartiesOrderBy {
  AbbreviationAsc = 'ABBREVIATION_ASC',
  AbbreviationDesc = 'ABBREVIATION_DESC',
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Party = Node & {
  __typename?: 'Party';
  abbreviation: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `Assistant`. */
  assistantsByPartyId: AssistantsConnection;
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `MemberElection`. */
  memberElectionsByPartyId: MemberElectionsConnection;
  /** Reads and enables pagination through a set of `MemberParliament`. */
  memberParliamentsByPartyId: MemberParliamentsConnection;
  /** Reads and enables pagination through a set of `Member`. */
  membersByPartyId: MembersConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type PartyAssistantsByPartyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssistantCondition>;
  filter?: InputMaybe<AssistantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssistantsOrderBy>>;
};


export type PartyMemberElectionsByPartyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberElectionCondition>;
  filter?: InputMaybe<MemberElectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberElectionsOrderBy>>;
};


export type PartyMemberParliamentsByPartyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


export type PartyMembersByPartyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};

/** A condition to be used against `Party` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PartyCondition = {
  /** Checks for equality with the object’s `abbreviation` field. */
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Party` object types. All fields are combined with a logical ‘and.’ */
export type PartyFilter = {
  /** Filter by the object’s `abbreviation` field. */
  abbreviation?: InputMaybe<StringFilter>;
  /** Filter by the object’s `assistantsByPartyId` relation. */
  assistantsByPartyId?: InputMaybe<PartyToManyAssistantFilter>;
  /** Some related `assistantsByPartyId` exist. */
  assistantsByPartyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberElectionsByPartyId` relation. */
  memberElectionsByPartyId?: InputMaybe<PartyToManyMemberElectionFilter>;
  /** Some related `memberElectionsByPartyId` exist. */
  memberElectionsByPartyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberParliamentsByPartyId` relation. */
  memberParliamentsByPartyId?: InputMaybe<PartyToManyMemberParliamentFilter>;
  /** Some related `memberParliamentsByPartyId` exist. */
  memberParliamentsByPartyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membersByPartyId` relation. */
  membersByPartyId?: InputMaybe<PartyToManyMemberFilter>;
  /** Some related `membersByPartyId` exist. */
  membersByPartyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `Assistant` object types. All fields are combined with a logical ‘and.’ */
export type PartyToManyAssistantFilter = {
  /** Every related `Assistant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssistantFilter>;
  /** No related `Assistant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssistantFilter>;
  /** Some related `Assistant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssistantFilter>;
};

/** A filter to be used against many `MemberElection` object types. All fields are combined with a logical ‘and.’ */
export type PartyToManyMemberElectionFilter = {
  /** Every related `MemberElection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberElectionFilter>;
  /** No related `MemberElection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberElectionFilter>;
  /** Some related `MemberElection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberElectionFilter>;
};

/** A filter to be used against many `Member` object types. All fields are combined with a logical ‘and.’ */
export type PartyToManyMemberFilter = {
  /** Every related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberFilter>;
  /** No related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberFilter>;
  /** Some related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberFilter>;
};

/** A filter to be used against many `MemberParliament` object types. All fields are combined with a logical ‘and.’ */
export type PartyToManyMemberParliamentFilter = {
  /** Every related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberParliamentFilter>;
  /** No related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberParliamentFilter>;
  /** Some related `MemberParliament` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberParliamentFilter>;
};

export type PositionType = Node & {
  __typename?: 'PositionType';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `PositionType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PositionTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `PositionType` object types. All fields are combined with a logical ‘and.’ */
export type PositionTypeFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
};

/** A connection to a list of `PositionType` values. */
export type PositionTypesConnection = {
  __typename?: 'PositionTypesConnection';
  /** A list of edges which contains the `PositionType` and cursor to aid in pagination. */
  edges: Array<PositionTypesEdge>;
  /** A list of `PositionType` objects. */
  nodes: Array<PositionType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PositionType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PositionType` edge in the connection. */
export type PositionTypesEdge = {
  __typename?: 'PositionTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PositionType` at the end of the edge. */
  node: PositionType;
};

/** Methods to use when ordering `PositionType`. */
export enum PositionTypesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type PostalCodeLookup = {
  __typename?: 'PostalCodeLookup';
  /** Reads a single `Constituency` that is related to this `PostalCodeLookup`. */
  constituencyByConstituencyId?: Maybe<Constituency>;
  constituencyId?: Maybe<Scalars['Int']['output']>;
  postalCode: Scalars['String']['output'];
};

/**
 * A condition to be used against `PostalCodeLookup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PostalCodeLookupCondition = {
  /** Checks for equality with the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `postalCode` field. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `PostalCodeLookup` object types. All fields are combined with a logical ‘and.’ */
export type PostalCodeLookupFilter = {
  /** Filter by the object’s `constituencyByConstituencyId` relation. */
  constituencyByConstituencyId?: InputMaybe<ConstituencyFilter>;
  /** A related `constituencyByConstituencyId` exists. */
  constituencyByConstituencyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `constituencyId` field. */
  constituencyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `postalCode` field. */
  postalCode?: InputMaybe<StringFilter>;
};

/** A connection to a list of `PostalCodeLookup` values. */
export type PostalCodeLookupsConnection = {
  __typename?: 'PostalCodeLookupsConnection';
  /** A list of edges which contains the `PostalCodeLookup` and cursor to aid in pagination. */
  edges: Array<PostalCodeLookupsEdge>;
  /** A list of `PostalCodeLookup` objects. */
  nodes: Array<PostalCodeLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PostalCodeLookup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PostalCodeLookup` edge in the connection. */
export type PostalCodeLookupsEdge = {
  __typename?: 'PostalCodeLookupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PostalCodeLookup` at the end of the edge. */
  node: PostalCodeLookup;
};

/** Methods to use when ordering `PostalCodeLookup`. */
export enum PostalCodeLookupsOrderBy {
  ConstituencyIdAsc = 'CONSTITUENCY_ID_ASC',
  ConstituencyIdDesc = 'CONSTITUENCY_ID_DESC',
  Natural = 'NATURAL',
  PostalCodeAsc = 'POSTAL_CODE_ASC',
  PostalCodeDesc = 'POSTAL_CODE_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads and enables pagination through a set of `AssistantConstituencyOffice`. */
  allAssistantConstituencyOffices?: Maybe<AssistantConstituencyOfficesConnection>;
  /** Reads and enables pagination through a set of `AssistantMember`. */
  allAssistantMembers?: Maybe<AssistantMembersConnection>;
  /** Reads and enables pagination through a set of `Assistant`. */
  allAssistants?: Maybe<AssistantsConnection>;
  /** Reads and enables pagination through a set of `ClerkType`. */
  allClerkTypes?: Maybe<ClerkTypesConnection>;
  /** Reads and enables pagination through a set of `Clerk`. */
  allClerks?: Maybe<ClerksConnection>;
  /** Reads and enables pagination through a set of `Community`. */
  allCommunities?: Maybe<CommunitiesConnection>;
  /** Reads and enables pagination through a set of `Constituency`. */
  allConstituencies?: Maybe<ConstituenciesConnection>;
  /** Reads and enables pagination through a set of `ConstituencyOffice`. */
  allConstituencyOffices?: Maybe<ConstituencyOfficesConnection>;
  /** Reads and enables pagination through a set of `ExecutiveCouncil`. */
  allExecutiveCouncils?: Maybe<ExecutiveCouncilsConnection>;
  /** Reads and enables pagination through a set of `ExecutiveStaffPosition`. */
  allExecutiveStaffPositions?: Maybe<ExecutiveStaffPositionsConnection>;
  /** Reads and enables pagination through a set of `ExecutiveStaff`. */
  allExecutiveStaffs?: Maybe<ExecutiveStaffsConnection>;
  /** Reads and enables pagination through a set of `Image`. */
  allImages?: Maybe<ImagesConnection>;
  /** Reads and enables pagination through a set of `LegislativeAssistant`. */
  allLegislativeAssistants?: Maybe<LegislativeAssistantsConnection>;
  /** Reads and enables pagination through a set of `LegislatureBuilding`. */
  allLegislatureBuildings?: Maybe<LegislatureBuildingsConnection>;
  /** Reads and enables pagination through a set of `LegislatureOffice`. */
  allLegislatureOffices?: Maybe<LegislatureOfficesConnection>;
  /** Reads and enables pagination through a set of `MemberConstituency`. */
  allMemberConstituencies?: Maybe<MemberConstituenciesConnection>;
  /** Reads and enables pagination through a set of `MemberElection`. */
  allMemberElections?: Maybe<MemberElectionsConnection>;
  /** Reads and enables pagination through a set of `MemberParliament`. */
  allMemberParliaments?: Maybe<MemberParliamentsConnection>;
  /** Reads and enables pagination through a set of `MemberResignation`. */
  allMemberResignations?: Maybe<MemberResignationsConnection>;
  /** Reads and enables pagination through a set of `MemberRole`. */
  allMemberRoles?: Maybe<MemberRolesConnection>;
  /** Reads and enables pagination through a set of `MemberType`. */
  allMemberTypes?: Maybe<MemberTypesConnection>;
  /** Reads and enables pagination through a set of `Member`. */
  allMembers?: Maybe<MembersConnection>;
  /** Reads and enables pagination through a set of `MembersIndexLink`. */
  allMembersIndexLinks?: Maybe<MembersIndexLinksConnection>;
  /** Reads and enables pagination through a set of `Minister`. */
  allMinisters?: Maybe<MinistersConnection>;
  /** Reads and enables pagination through a set of `Parliament`. */
  allParliaments?: Maybe<ParliamentsConnection>;
  /** Reads and enables pagination through a set of `Party`. */
  allParties?: Maybe<PartiesConnection>;
  /** Reads and enables pagination through a set of `PositionType`. */
  allPositionTypes?: Maybe<PositionTypesConnection>;
  /** Reads and enables pagination through a set of `PostalCodeLookup`. */
  allPostalCodeLookups?: Maybe<PostalCodeLookupsConnection>;
  /** Reads and enables pagination through a set of `RoleType`. */
  allRoleTypes?: Maybe<RoleTypesConnection>;
  /** Reads and enables pagination through a set of `Role`. */
  allRoles?: Maybe<RolesConnection>;
  /** Reads and enables pagination through a set of `Session`. */
  allSessions?: Maybe<SessionsConnection>;
  /** Reads and enables pagination through a set of `SocialMediaLink`. */
  allSocialMediaLinks?: Maybe<SocialMediaLinksConnection>;
  /** Reads and enables pagination through a set of `SummaryType`. */
  allSummaryTypes?: Maybe<SummaryTypesConnection>;
  /** Reads and enables pagination through a set of `Version`. */
  allVersions?: Maybe<VersionsConnection>;
  /** Reads a single `Assistant` using its globally unique `ID`. */
  assistant?: Maybe<Assistant>;
  assistantById?: Maybe<Assistant>;
  /** Reads a single `AssistantConstituencyOffice` using its globally unique `ID`. */
  assistantConstituencyOffice?: Maybe<AssistantConstituencyOffice>;
  assistantConstituencyOfficeByAssistantIdAndConstituencyOfficeId?: Maybe<AssistantConstituencyOffice>;
  assistantConstituencyOfficeById?: Maybe<AssistantConstituencyOffice>;
  /** Reads a single `AssistantMember` using its globally unique `ID`. */
  assistantMember?: Maybe<AssistantMember>;
  assistantMemberByAssistantIdAndMemberId?: Maybe<AssistantMember>;
  assistantMemberById?: Maybe<AssistantMember>;
  /** Reads a single `Clerk` using its globally unique `ID`. */
  clerk?: Maybe<Clerk>;
  clerkById?: Maybe<Clerk>;
  /** Reads a single `ClerkType` using its globally unique `ID`. */
  clerkType?: Maybe<ClerkType>;
  clerkTypeById?: Maybe<ClerkType>;
  /** Reads a single `Community` using its globally unique `ID`. */
  community?: Maybe<Community>;
  communityById?: Maybe<Community>;
  /** Reads a single `Constituency` using its globally unique `ID`. */
  constituency?: Maybe<Constituency>;
  constituencyById?: Maybe<Constituency>;
  constituencyByName?: Maybe<Constituency>;
  /** Reads a single `ConstituencyOffice` using its globally unique `ID`. */
  constituencyOffice?: Maybe<ConstituencyOffice>;
  constituencyOfficeById?: Maybe<ConstituencyOffice>;
  /** Reads a single `ExecutiveCouncil` using its globally unique `ID`. */
  executiveCouncil?: Maybe<ExecutiveCouncil>;
  executiveCouncilById?: Maybe<ExecutiveCouncil>;
  /** Reads a single `ExecutiveStaff` using its globally unique `ID`. */
  executiveStaff?: Maybe<ExecutiveStaff>;
  executiveStaffById?: Maybe<ExecutiveStaff>;
  /** Reads a single `ExecutiveStaffPosition` using its globally unique `ID`. */
  executiveStaffPosition?: Maybe<ExecutiveStaffPosition>;
  executiveStaffPositionById?: Maybe<ExecutiveStaffPosition>;
  /** Reads a single `Image` using its globally unique `ID`. */
  image?: Maybe<Image>;
  imageById?: Maybe<Image>;
  /** Reads a single `LegislativeAssistant` using its globally unique `ID`. */
  legislativeAssistant?: Maybe<LegislativeAssistant>;
  legislativeAssistantById?: Maybe<LegislativeAssistant>;
  /** Reads a single `LegislatureBuilding` using its globally unique `ID`. */
  legislatureBuilding?: Maybe<LegislatureBuilding>;
  legislatureBuildingById?: Maybe<LegislatureBuilding>;
  /** Reads a single `LegislatureOffice` using its globally unique `ID`. */
  legislatureOffice?: Maybe<LegislatureOffice>;
  legislatureOfficeById?: Maybe<LegislatureOffice>;
  /** Reads a single `Member` using its globally unique `ID`. */
  member?: Maybe<Member>;
  memberById?: Maybe<Member>;
  /** Reads a single `MemberElection` using its globally unique `ID`. */
  memberElection?: Maybe<MemberElection>;
  memberElectionById?: Maybe<MemberElection>;
  /** Reads a single `MemberParliament` using its globally unique `ID`. */
  memberParliament?: Maybe<MemberParliament>;
  memberParliamentById?: Maybe<MemberParliament>;
  memberParliamentByMemberIdAndParliamentId?: Maybe<MemberParliament>;
  /** Reads a single `MemberResignation` using its globally unique `ID`. */
  memberResignation?: Maybe<MemberResignation>;
  memberResignationById?: Maybe<MemberResignation>;
  /** Reads a single `MemberRole` using its globally unique `ID`. */
  memberRole?: Maybe<MemberRole>;
  memberRoleById?: Maybe<MemberRole>;
  /** Reads a single `MemberType` using its globally unique `ID`. */
  memberType?: Maybe<MemberType>;
  memberTypeById?: Maybe<MemberType>;
  /** Reads a single `MembersIndexLink` using its globally unique `ID`. */
  membersIndexLink?: Maybe<MembersIndexLink>;
  membersIndexLinkById?: Maybe<MembersIndexLink>;
  /** Reads a single `Minister` using its globally unique `ID`. */
  minister?: Maybe<Minister>;
  ministerById?: Maybe<Minister>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Parliament` using its globally unique `ID`. */
  parliament?: Maybe<Parliament>;
  parliamentById?: Maybe<Parliament>;
  parliamentByNumber?: Maybe<Parliament>;
  /** Reads a single `Party` using its globally unique `ID`. */
  party?: Maybe<Party>;
  partyByAbbreviation?: Maybe<Party>;
  partyById?: Maybe<Party>;
  partyByName?: Maybe<Party>;
  /** Reads a single `PositionType` using its globally unique `ID`. */
  positionType?: Maybe<PositionType>;
  positionTypeById?: Maybe<PositionType>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `Role` using its globally unique `ID`. */
  role?: Maybe<Role>;
  roleById?: Maybe<Role>;
  roleByTitle?: Maybe<Role>;
  /** Reads a single `RoleType` using its globally unique `ID`. */
  roleType?: Maybe<RoleType>;
  roleTypeById?: Maybe<RoleType>;
  /** Reads a single `Session` using its globally unique `ID`. */
  session?: Maybe<Session>;
  sessionById?: Maybe<Session>;
  sessionByParliamentIdAndNumber?: Maybe<Session>;
  /** Reads a single `SocialMediaLink` using its globally unique `ID`. */
  socialMediaLink?: Maybe<SocialMediaLink>;
  socialMediaLinkById?: Maybe<SocialMediaLink>;
  /** Reads a single `SummaryType` using its globally unique `ID`. */
  summaryType?: Maybe<SummaryType>;
  summaryTypeById?: Maybe<SummaryType>;
  /** Reads a single `Version` using its globally unique `ID`. */
  version?: Maybe<Version>;
  versionById?: Maybe<Version>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAssistantConstituencyOfficesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssistantConstituencyOfficeCondition>;
  filter?: InputMaybe<AssistantConstituencyOfficeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssistantConstituencyOfficesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAssistantMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssistantMemberCondition>;
  filter?: InputMaybe<AssistantMemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssistantMembersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAssistantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssistantCondition>;
  filter?: InputMaybe<AssistantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssistantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllClerkTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClerkTypeCondition>;
  filter?: InputMaybe<ClerkTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClerkTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllClerksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClerkCondition>;
  filter?: InputMaybe<ClerkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClerksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCommunitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommunityCondition>;
  filter?: InputMaybe<CommunityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommunitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllConstituenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConstituencyCondition>;
  filter?: InputMaybe<ConstituencyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConstituenciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllConstituencyOfficesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConstituencyOfficeCondition>;
  filter?: InputMaybe<ConstituencyOfficeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConstituencyOfficesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExecutiveCouncilsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ExecutiveCouncilCondition>;
  filter?: InputMaybe<ExecutiveCouncilFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExecutiveCouncilsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExecutiveStaffPositionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ExecutiveStaffPositionCondition>;
  filter?: InputMaybe<ExecutiveStaffPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExecutiveStaffPositionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExecutiveStaffsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ExecutiveStaffCondition>;
  filter?: InputMaybe<ExecutiveStaffFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExecutiveStaffsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllImagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ImageCondition>;
  filter?: InputMaybe<ImageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLegislativeAssistantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LegislativeAssistantCondition>;
  filter?: InputMaybe<LegislativeAssistantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LegislativeAssistantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLegislatureBuildingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LegislatureBuildingCondition>;
  filter?: InputMaybe<LegislatureBuildingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LegislatureBuildingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLegislatureOfficesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LegislatureOfficeCondition>;
  filter?: InputMaybe<LegislatureOfficeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LegislatureOfficesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMemberConstituenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberConstituencyCondition>;
  filter?: InputMaybe<MemberConstituencyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberConstituenciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMemberElectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberElectionCondition>;
  filter?: InputMaybe<MemberElectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberElectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMemberParliamentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberParliamentCondition>;
  filter?: InputMaybe<MemberParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberParliamentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMemberResignationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberResignationCondition>;
  filter?: InputMaybe<MemberResignationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberResignationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMemberRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberRoleCondition>;
  filter?: InputMaybe<MemberRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMemberTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberTypeCondition>;
  filter?: InputMaybe<MemberTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMembersIndexLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembersIndexLinkCondition>;
  filter?: InputMaybe<MembersIndexLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersIndexLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMinistersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MinisterCondition>;
  filter?: InputMaybe<MinisterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MinistersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllParliamentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ParliamentCondition>;
  filter?: InputMaybe<ParliamentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParliamentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPartiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PartyCondition>;
  filter?: InputMaybe<PartyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PartiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPositionTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PositionTypeCondition>;
  filter?: InputMaybe<PositionTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PositionTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPostalCodeLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PostalCodeLookupCondition>;
  filter?: InputMaybe<PostalCodeLookupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PostalCodeLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRoleTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoleTypeCondition>;
  filter?: InputMaybe<RoleTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoleTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoleCondition>;
  filter?: InputMaybe<RoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SessionCondition>;
  filter?: InputMaybe<SessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SessionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSocialMediaLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SocialMediaLinkCondition>;
  filter?: InputMaybe<SocialMediaLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SocialMediaLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSummaryTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SummaryTypeCondition>;
  filter?: InputMaybe<SummaryTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SummaryTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VersionCondition>;
  filter?: InputMaybe<VersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VersionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssistantArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssistantByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssistantConstituencyOfficeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssistantConstituencyOfficeByAssistantIdAndConstituencyOfficeIdArgs = {
  assistantId: Scalars['Int']['input'];
  constituencyOfficeId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssistantConstituencyOfficeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssistantMemberArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssistantMemberByAssistantIdAndMemberIdArgs = {
  assistantId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssistantMemberByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClerkArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClerkByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClerkTypeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClerkTypeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommunityArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommunityByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConstituencyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConstituencyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConstituencyByNameArgs = {
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConstituencyOfficeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConstituencyOfficeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExecutiveCouncilArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExecutiveCouncilByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExecutiveStaffArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExecutiveStaffByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExecutiveStaffPositionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExecutiveStaffPositionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryImageArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryImageByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLegislativeAssistantArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLegislativeAssistantByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLegislatureBuildingArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLegislatureBuildingByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLegislatureOfficeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLegislatureOfficeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberElectionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberElectionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberParliamentArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberParliamentByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberParliamentByMemberIdAndParliamentIdArgs = {
  memberId: Scalars['Int']['input'];
  parliamentId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberResignationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberResignationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberRoleArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberRoleByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberTypeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberTypeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembersIndexLinkArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembersIndexLinkByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMinisterArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMinisterByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryParliamentArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryParliamentByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryParliamentByNumberArgs = {
  number: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPartyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPartyByAbbreviationArgs = {
  abbreviation: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPartyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPartyByNameArgs = {
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPositionTypeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPositionTypeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoleArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoleByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoleByTitleArgs = {
  title: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoleTypeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoleTypeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionByParliamentIdAndNumberArgs = {
  number: Scalars['Int']['input'];
  parliamentId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySocialMediaLinkArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySocialMediaLinkByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySummaryTypeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySummaryTypeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVersionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVersionByIdArgs = {
  id: Scalars['Int']['input'];
};

export type Role = Node & {
  __typename?: 'Role';
  active: Scalars['Boolean']['output'];
  details?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `MemberRole`. */
  memberRolesByRoleId: MemberRolesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `RoleType` that is related to this `Role`. */
  roleTypeByTypeId?: Maybe<RoleType>;
  title: Scalars['String']['output'];
  typeId: Scalars['Int']['output'];
};


export type RoleMemberRolesByRoleIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberRoleCondition>;
  filter?: InputMaybe<MemberRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberRolesOrderBy>>;
};

/** A condition to be used against `Role` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type RoleCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Role` object types. All fields are combined with a logical ‘and.’ */
export type RoleFilter = {
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memberRolesByRoleId` relation. */
  memberRolesByRoleId?: InputMaybe<RoleToManyMemberRoleFilter>;
  /** Some related `memberRolesByRoleId` exist. */
  memberRolesByRoleIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `roleTypeByTypeId` relation. */
  roleTypeByTypeId?: InputMaybe<RoleTypeFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<IntFilter>;
};

/** A filter to be used against many `MemberRole` object types. All fields are combined with a logical ‘and.’ */
export type RoleToManyMemberRoleFilter = {
  /** Every related `MemberRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberRoleFilter>;
  /** No related `MemberRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberRoleFilter>;
  /** Some related `MemberRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberRoleFilter>;
};

export type RoleType = Node & {
  __typename?: 'RoleType';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Role`. */
  rolesByTypeId: RolesConnection;
};


export type RoleTypeRolesByTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoleCondition>;
  filter?: InputMaybe<RoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
};

/**
 * A condition to be used against `RoleType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RoleTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `RoleType` object types. All fields are combined with a logical ‘and.’ */
export type RoleTypeFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rolesByTypeId` relation. */
  rolesByTypeId?: InputMaybe<RoleTypeToManyRoleFilter>;
  /** Some related `rolesByTypeId` exist. */
  rolesByTypeIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against many `Role` object types. All fields are combined with a logical ‘and.’ */
export type RoleTypeToManyRoleFilter = {
  /** Every related `Role` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoleFilter>;
  /** No related `Role` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoleFilter>;
  /** Some related `Role` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoleFilter>;
};

/** A connection to a list of `RoleType` values. */
export type RoleTypesConnection = {
  __typename?: 'RoleTypesConnection';
  /** A list of edges which contains the `RoleType` and cursor to aid in pagination. */
  edges: Array<RoleTypesEdge>;
  /** A list of `RoleType` objects. */
  nodes: Array<RoleType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoleType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RoleType` edge in the connection. */
export type RoleTypesEdge = {
  __typename?: 'RoleTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RoleType` at the end of the edge. */
  node: RoleType;
};

/** Methods to use when ordering `RoleType`. */
export enum RoleTypesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Role` values. */
export type RolesConnection = {
  __typename?: 'RolesConnection';
  /** A list of edges which contains the `Role` and cursor to aid in pagination. */
  edges: Array<RolesEdge>;
  /** A list of `Role` objects. */
  nodes: Array<Role>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Role` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Role` edge in the connection. */
export type RolesEdge = {
  __typename?: 'RolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Role` at the end of the edge. */
  node: Role;
};

/** Methods to use when ordering `Role`. */
export enum RolesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC'
}

export type Session = Node & {
  __typename?: 'Session';
  active: Scalars['Boolean']['output'];
  annotation?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  /** Reads a single `Parliament` that is related to this `Session`. */
  parliamentByParliamentId?: Maybe<Parliament>;
  parliamentId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
};

/** A condition to be used against `Session` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SessionCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `annotation` field. */
  annotation?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `number` field. */
  number?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `parliamentId` field. */
  parliamentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** A filter to be used against `Session` object types. All fields are combined with a logical ‘and.’ */
export type SessionFilter = {
  /** Filter by the object’s `annotation` field. */
  annotation?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `number` field. */
  number?: InputMaybe<IntFilter>;
  /** Filter by the object’s `parliamentByParliamentId` relation. */
  parliamentByParliamentId?: InputMaybe<ParliamentFilter>;
  /** Filter by the object’s `parliamentId` field. */
  parliamentId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `Session` values. */
export type SessionsConnection = {
  __typename?: 'SessionsConnection';
  /** A list of edges which contains the `Session` and cursor to aid in pagination. */
  edges: Array<SessionsEdge>;
  /** A list of `Session` objects. */
  nodes: Array<Session>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Session` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Session` edge in the connection. */
export type SessionsEdge = {
  __typename?: 'SessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Session` at the end of the edge. */
  node: Session;
};

/** Methods to use when ordering `Session`. */
export enum SessionsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  AnnotationAsc = 'ANNOTATION_ASC',
  AnnotationDesc = 'ANNOTATION_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  ParliamentIdAsc = 'PARLIAMENT_ID_ASC',
  ParliamentIdDesc = 'PARLIAMENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

export type SocialMediaLink = Node & {
  __typename?: 'SocialMediaLink';
  id: Scalars['Int']['output'];
  linkName: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `SocialMediaLink`. */
  memberByMemberId?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

/**
 * A condition to be used against `SocialMediaLink` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SocialMediaLinkCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `linkName` field. */
  linkName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `SocialMediaLink` object types. All fields are combined with a logical ‘and.’ */
export type SocialMediaLinkFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `linkName` field. */
  linkName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `memberByMemberId` relation. */
  memberByMemberId?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
};

/** A connection to a list of `SocialMediaLink` values. */
export type SocialMediaLinksConnection = {
  __typename?: 'SocialMediaLinksConnection';
  /** A list of edges which contains the `SocialMediaLink` and cursor to aid in pagination. */
  edges: Array<SocialMediaLinksEdge>;
  /** A list of `SocialMediaLink` objects. */
  nodes: Array<SocialMediaLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SocialMediaLink` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SocialMediaLink` edge in the connection. */
export type SocialMediaLinksEdge = {
  __typename?: 'SocialMediaLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SocialMediaLink` at the end of the edge. */
  node: SocialMediaLink;
};

/** Methods to use when ordering `SocialMediaLink`. */
export enum SocialMediaLinksOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LinkNameAsc = 'LINK_NAME_ASC',
  LinkNameDesc = 'LINK_NAME_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SummaryType = Node & {
  __typename?: 'SummaryType';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `SummaryType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SummaryTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `SummaryType` object types. All fields are combined with a logical ‘and.’ */
export type SummaryTypeFilter = {
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
};

/** A connection to a list of `SummaryType` values. */
export type SummaryTypesConnection = {
  __typename?: 'SummaryTypesConnection';
  /** A list of edges which contains the `SummaryType` and cursor to aid in pagination. */
  edges: Array<SummaryTypesEdge>;
  /** A list of `SummaryType` objects. */
  nodes: Array<SummaryType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SummaryType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SummaryType` edge in the connection. */
export type SummaryTypesEdge = {
  __typename?: 'SummaryTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SummaryType` at the end of the edge. */
  node: SummaryType;
};

/** Methods to use when ordering `SummaryType`. */
export enum SummaryTypesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Version = Node & {
  __typename?: 'Version';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
};

/** A condition to be used against `Version` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type VersionCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `number` field. */
  number?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Version` object types. All fields are combined with a logical ‘and.’ */
export type VersionFilter = {
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `number` field. */
  number?: InputMaybe<IntFilter>;
};

/** A connection to a list of `Version` values. */
export type VersionsConnection = {
  __typename?: 'VersionsConnection';
  /** A list of edges which contains the `Version` and cursor to aid in pagination. */
  edges: Array<VersionsEdge>;
  /** A list of `Version` objects. */
  nodes: Array<Version>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Version` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Version` edge in the connection. */
export type VersionsEdge = {
  __typename?: 'VersionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Version` at the end of the edge. */
  node: Version;
};

/** Methods to use when ordering `Version`. */
export enum VersionsOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type GetMlaNameQueryVariables = Exact<{
  postalCode: Scalars['String']['input'];
}>;


export type GetMlaNameQuery = { __typename?: 'Query', allPostalCodeLookups?: { __typename?: 'PostalCodeLookupsConnection', nodes: Array<{ __typename?: 'PostalCodeLookup', constituencyByConstituencyId?: { __typename?: 'Constituency', memberByMemberId?: { __typename?: 'Member', firstName: string, lastName: string } | null } | null }> } | null };

export type GetAllMlAsQueryVariables = Exact<{
  parliamentId: Scalars['Int']['input'];
}>;


export type GetAllMlAsQuery = { __typename?: 'Query', allMemberParliaments?: { __typename?: 'MemberParliamentsConnection', nodes: Array<{ __typename?: 'MemberParliament', isHonourable: boolean, isCounsel: boolean, aboutMember?: string | null, active: boolean, constituencyId?: number | null, id: number, image?: { __typename?: 'Image', path: string, description: string } | null, memberByMemberId?: { __typename?: 'Member', dietaryRestrictions?: string | null, electionYears?: string | null, firstName: string, govEmail?: string | null, lastName: string, legislativeEmail?: string | null, legislativeOfficeId?: number | null, memberTypeId?: number | null, middleName?: string | null, officePhone?: string | null, primaryConstituencyOfficeId?: number | null, primaryRoleId?: number | null, prefix?: string | null } | null }> } | null };

export type GetCurrentParliamentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentParliamentQuery = { __typename?: 'Query', allParliaments?: { __typename?: 'ParliamentsConnection', nodes: Array<{ __typename?: 'Parliament', number: number, annotation?: string | null, id: number, sessionsByParliamentId: { __typename?: 'SessionsConnection', nodes: Array<{ __typename?: 'Session', number: number, id: number, annotation?: string | null }> } }> } | null };

export type GetAllParliamentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllParliamentsQuery = { __typename?: 'Query', allParliaments?: { __typename?: 'ParliamentsConnection', nodes: Array<{ __typename?: 'Parliament', number: number, annotation?: string | null, id: number, endDate?: any | null, startDate?: any | null, sessionsByParliamentId: { __typename?: 'SessionsConnection', nodes: Array<{ __typename?: 'Session', number: number, id: number, annotation?: string | null, endDate?: any | null, startDate?: any | null, parliamentId: number }> } }> } | null };

export type GetExecutiveCouncilQueryVariables = Exact<{
  parliament: Scalars['Int']['input'];
}>;


export type GetExecutiveCouncilQuery = { __typename?: 'Query', allMemberParliaments?: { __typename?: 'MemberParliamentsConnection', nodes: Array<{ __typename?: 'MemberParliament', id: number, isHonourable: boolean, isCounsel: boolean, memberByMemberId?: { __typename?: 'Member', firstName: string, lastName: string } | null, memberRolesByMemberParliamentId: { __typename?: 'MemberRolesConnection', nodes: Array<{ __typename?: 'MemberRole', roleId: number, active: boolean, endDate?: any | null, roleByRoleId?: { __typename?: 'Role', title: string, typeId: number } | null }> } }> } | null };

export type GetDissolutionMembersQueryVariables = Exact<{
  parNumber: Scalars['Int']['input'];
}>;


export type GetDissolutionMembersQuery = { __typename?: 'Query', allMemberParliaments?: { __typename?: 'MemberParliamentsConnection', totalCount: number, nodes: Array<{ __typename?: 'MemberParliament', isHonourable: boolean, isCounsel: boolean, isDoctor: boolean, image?: { __typename?: 'Image', path: string, description: string } | null, member?: { __typename?: 'Member', firstName: string, lastName: string } | null, parliament?: { __typename?: 'Parliament', number: number, annotation?: string | null, startDate?: any | null, endDate?: any | null } | null }> } | null };

export type GetMlaQueryVariables = Exact<{
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  parliament: Scalars['Int']['input'];
}>;


export type GetMlaQuery = { __typename?: 'Query', allMembers?: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: number, firstName: string, lastName: string, electionYears?: string | null, legislativeEmail?: string | null, memberParliamentsByMemberId: { __typename?: 'MemberParliamentsConnection', nodes: Array<{ __typename?: 'MemberParliament', id: number, aboutMember?: string | null, active: boolean, govEmail?: string | null, isHonourable: boolean, isDoctor: boolean, isCounsel: boolean, legislativeOfficeId?: number | null, officePhone?: string | null, parliamentByParliamentId?: { __typename?: 'Parliament', endDate?: any | null, active: boolean, number: number, session: { __typename?: 'SessionsConnection', nodes: Array<{ __typename?: 'Session', number: number, annotation?: string | null }> } } | null, image?: { __typename?: 'Image', path: string, description: string } | null, party?: { __typename?: 'Party', abbreviation: string } | null, constituency?: { __typename?: 'Constituency', name: string, offices: { __typename?: 'ConstituencyOfficesConnection', nodes: Array<{ __typename?: 'ConstituencyOffice', active: boolean, address: string, city: string, constituencyId: number, email?: string | null, fax?: string | null, name?: string | null, phoneNumber?: string | null, postalcode: string, province: string, tollFreePhone?: string | null }> } } | null, legOffice?: { __typename?: 'LegislatureOffice', email?: string | null, fax?: string | null, name?: string | null, phone?: string | null, roomNumber?: number | null, legBuilding?: { __typename?: 'LegislatureBuilding', address: string, city: string, postalcode: string, province: string, name: string } | null } | null, ministry: { __typename?: 'MemberRolesConnection', nodes: Array<{ __typename?: 'MemberRole', endDate?: any | null, roleByRoleId?: { __typename?: 'Role', title: string, email?: string | null, details?: string | null } | null }> } }> } }> } | null, allParliaments?: { __typename?: 'ParliamentsConnection', nodes: Array<{ __typename?: 'Parliament', number: number, annotation?: string | null, id: number, sessionsByParliamentId: { __typename?: 'SessionsConnection', nodes: Array<{ __typename?: 'Session', number: number, id: number, annotation?: string | null }> } }> } | null };

export type GetMlAsByCommunityQueryVariables = Exact<{
  parliamentId: Scalars['Int']['input'];
}>;


export type GetMlAsByCommunityQuery = { __typename?: 'Query', allMemberParliaments?: { __typename?: 'MemberParliamentsConnection', nodes: Array<{ __typename?: 'MemberParliament', isCounsel: boolean, isDoctor: boolean, isHonourable: boolean, constituencyId?: number | null, member?: { __typename?: 'Member', prefix?: string | null, firstName: string, lastName: string } | null, party?: { __typename?: 'Party', abbreviation: string } | null, constituency?: { __typename?: 'Constituency', id: number, name: string, community: { __typename?: 'CommunitiesConnection', nodes: Array<{ __typename?: 'Community', id: number, constituencyId?: number | null, electoralMapLabel?: string | null, electoralMapLink?: string | null, title: string }> } } | null }> } | null };

export type GetMlAsByConstituencyQueryVariables = Exact<{
  parliamentId: Scalars['Int']['input'];
}>;


export type GetMlAsByConstituencyQuery = { __typename?: 'Query', allMemberParliaments?: { __typename?: 'MemberParliamentsConnection', nodes: Array<{ __typename?: 'MemberParliament', isCounsel: boolean, isDoctor: boolean, isHonourable: boolean, nodeId: string, image?: { __typename?: 'Image', path: string, description: string } | null, constituency?: { __typename?: 'Constituency', name: string } | null, member?: { __typename?: 'Member', firstName: string, lastName: string } | null, party?: { __typename?: 'Party', name: string, abbreviation: string } | null }> } | null };

export type MyQueryQueryVariables = Exact<{
  number: Scalars['Int']['input'];
}>;


export type MyQueryQuery = { __typename?: 'Query', allParliaments?: { __typename?: 'ParliamentsConnection', nodes: Array<{ __typename?: 'Parliament', sessionsByParliamentId: { __typename?: 'SessionsConnection', nodes: Array<{ __typename?: 'Session', number: number, annotation?: string | null }> } }> } | null };

export type GetPartyStandingsQueryVariables = Exact<{
  parliamentId: Scalars['Int']['input'];
}>;


export type GetPartyStandingsQuery = { __typename?: 'Query', allParties?: { __typename?: 'PartiesConnection', nodes: Array<{ __typename?: 'Party', abbreviation: string, name: string, nodeId: string, members: { __typename?: 'MemberParliamentsConnection', totalCount: number } }> } | null, allMemberParliaments?: { __typename?: 'MemberParliamentsConnection', totalCount: number } | null };

export type GetBillMembersQueryVariables = Exact<{
  in?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetBillMembersQuery = { __typename?: 'Query', allMembers?: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: number, firstName: string, lastName: string, isHonourable: boolean, isDoctor: boolean }> } | null };

export type GetMemberCountQueryVariables = Exact<{
  parNumber: Scalars['Int']['input'];
}>;


export type GetMemberCountQuery = { __typename?: 'Query', allMemberParliaments?: { __typename?: 'MemberParliamentsConnection', totalCount: number } | null, allParliaments?: { __typename?: 'ParliamentsConnection', nodes: Array<{ __typename?: 'Parliament', number: number, annotation?: string | null, id: number, sessionsByParliamentId: { __typename?: 'SessionsConnection', nodes: Array<{ __typename?: 'Session', number: number, id: number, annotation?: string | null }> } }> } | null };


export const GetMlaNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMLAName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allPostalCodeLookups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constituencyByConstituencyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberByMemberId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMlaNameQuery, GetMlaNameQueryVariables>;
export const GetAllMlAsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllMLAs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parliamentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMemberParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"parliamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parliamentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHonourable"}},{"kind":"Field","name":{"kind":"Name","value":"isCounsel"}},{"kind":"Field","name":{"kind":"Name","value":"aboutMember"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"constituencyId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"imageBySmallImageId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberByMemberId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dietaryRestrictions"}},{"kind":"Field","name":{"kind":"Name","value":"electionYears"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"govEmail"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"legislativeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"legislativeOfficeId"}},{"kind":"Field","name":{"kind":"Name","value":"memberTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"officePhone"}},{"kind":"Field","name":{"kind":"Name","value":"primaryConstituencyOfficeId"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRoleId"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllMlAsQuery, GetAllMlAsQueryVariables>;
export const GetCurrentParliamentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentParliament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NUMBER_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sessionsByParliamentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NUMBER_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentParliamentQuery, GetCurrentParliamentQueryVariables>;
export const GetAllParliamentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllParliaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NUMBER_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sessionsByParliamentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NUMBER_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"parliamentId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllParliamentsQuery, GetAllParliamentsQueryVariables>;
export const GetExecutiveCouncilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExecutiveCouncil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parliament"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMemberParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parliamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parliament"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberRolesByMemberParliamentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roleByRoleId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberByMemberId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberRolesByMemberParliamentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roleByRoleId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"IntValue","value":"1"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"roleByRoleId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isHonourable"}},{"kind":"Field","name":{"kind":"Name","value":"isCounsel"}}]}}]}}]}}]} as unknown as DocumentNode<GetExecutiveCouncilQuery, GetExecutiveCouncilQueryVariables>;
export const GetDissolutionMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDissolutionMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMemberParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parliamentByParliamentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"parNumber"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHonourable"}},{"kind":"Field","name":{"kind":"Name","value":"isCounsel"}},{"kind":"Field","name":{"kind":"Name","value":"isDoctor"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"imageBySmallImageId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"member"},"name":{"kind":"Name","value":"memberByMemberId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"parliament"},"name":{"kind":"Name","value":"parliamentByParliamentId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetDissolutionMembersQuery, GetDissolutionMembersQueryVariables>;
export const GetMlaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMLA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parliament"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"electionYears"}},{"kind":"Field","name":{"kind":"Name","value":"legislativeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"memberParliamentsByMemberId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parliamentByParliamentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"parliament"}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aboutMember"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"govEmail"}},{"kind":"Field","name":{"kind":"Name","value":"isHonourable"}},{"kind":"Field","name":{"kind":"Name","value":"isDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"isCounsel"}},{"kind":"Field","name":{"kind":"Name","value":"legislativeOfficeId"}},{"kind":"Field","name":{"kind":"Name","value":"officePhone"}},{"kind":"Field","name":{"kind":"Name","value":"parliamentByParliamentId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","alias":{"kind":"Name","value":"session"},"name":{"kind":"Name","value":"sessionsByParliamentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"imageByMediumImageId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"party"},"name":{"kind":"Name","value":"partyByPartyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"constituency"},"name":{"kind":"Name","value":"constituencyByConstituencyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"offices"},"name":{"kind":"Name","value":"constituencyOfficesByConstituencyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"constituencyId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"postalcode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"tollFreePhone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"legOffice"},"name":{"kind":"Name","value":"legislatureOfficeByLegislativeOfficeId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"roomNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"legBuilding"},"name":{"kind":"Name","value":"legislatureBuildingByBuildingId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalcode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ministry"},"name":{"kind":"Name","value":"memberRolesByMemberParliamentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"roleByRoleId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NUMBER_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sessionsByParliamentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NUMBER_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMlaQuery, GetMlaQueryVariables>;
export const GetMlAsByCommunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMLAsByCommunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parliamentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMemberParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parliamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parliamentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCounsel"}},{"kind":"Field","name":{"kind":"Name","value":"isDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"isHonourable"}},{"kind":"Field","alias":{"kind":"Name","value":"member"},"name":{"kind":"Name","value":"memberByMemberId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"party"},"name":{"kind":"Name","value":"partyByPartyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constituencyId"}},{"kind":"Field","alias":{"kind":"Name","value":"constituency"},"name":{"kind":"Name","value":"constituencyByConstituencyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"community"},"name":{"kind":"Name","value":"communitiesByConstituencyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constituencyId"}},{"kind":"Field","name":{"kind":"Name","value":"electoralMapLabel"}},{"kind":"Field","name":{"kind":"Name","value":"electoralMapLink"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMlAsByCommunityQuery, GetMlAsByCommunityQueryVariables>;
export const GetMlAsByConstituencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMLAsByConstituency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parliamentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMemberParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parliamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parliamentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"imageBySmallImageId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"constituency"},"name":{"kind":"Name","value":"constituencyByConstituencyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"member"},"name":{"kind":"Name","value":"memberByMemberId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCounsel"}},{"kind":"Field","name":{"kind":"Name","value":"isDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"isHonourable"}},{"kind":"Field","alias":{"kind":"Name","value":"party"},"name":{"kind":"Name","value":"partyByPartyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}}]}}]}}]}}]} as unknown as DocumentNode<GetMlAsByConstituencyQuery, GetMlAsByConstituencyQueryVariables>;
export const MyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionsByParliamentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyQueryQuery, MyQueryQueryVariables>;
export const GetPartyStandingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPartyStandings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parliamentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allParties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"members"},"name":{"kind":"Name","value":"memberParliamentsByPartyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parliamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parliamentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allMemberParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"parliamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parliamentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetPartyStandingsQuery, GetPartyStandingsQueryVariables>;
export const GetBillMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBillMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"in"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"in"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isHonourable"}},{"kind":"Field","name":{"kind":"Name","value":"isDoctor"}}]}}]}}]}}]} as unknown as DocumentNode<GetBillMembersQuery, GetBillMembersQueryVariables>;
export const GetMemberCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMemberCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMemberParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parliamentByParliamentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"parNumber"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allParliaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parNumber"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NUMBER_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sessionsByParliamentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NUMBER_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"annotation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMemberCountQuery, GetMemberCountQueryVariables>;